//缺6、吊夹
import makerjs from "makerjs";
/**
 * 相离两个圆 已经两个圆圆心坐标 求两圆最近点坐标
 * 定两个相离的圆C1和C2；圆心坐标分别为(x1,y1)和(x2,y2),半径分别为 r1和r2.
 * 由于两圆相离，最近点位于两圆心的连线上。以下是求解步骤：
 * 1. 计算圆心距离
 * 首先计算两圆心的距离d;
 * d=Math.sqrt((x2-x1)*(x2-x1)+(y2-y1)*(y2-y1));
 * 2. 确定最近点方向
 * 两圆的最近点位于从C1到C2的连线上。设最近点为P，则P的坐标可以通过以下公式计算：
 * P=(x1+r1*(x2-x1)/d,y1+r1*(y2-y1)/d)
 * P=(x2-r2*(x2-x1)/d,y2-r2*(y2-y1)/d)
 * 这两个公式分别表示从C1出发向外延伸r1距离，或从C2出发向内延伸r2距离。
 * 3. 验证结果
 * 由于两圆相离，最近点P应满足：
 * 距离（P,C1）=r1 且 距离 (P,C2)=d-r2
 * 示例假设C1的圆心为(0,0),半径r1=2,C2的圆心为（5,0）,半径r2=1;
 * 1、计算圆心距离：
 * d=Math.sqrt((5-0)*(5-0)+(0-0)*(0-0))=5
 * 2、计算最近点P;
 * P=(0+2/5*5,0+2/5*0)=(2,0)
 * 验证：
 * 距离（P,C1）=Math.sqrt((2-0)*(2-0)+(0,0)*(0,0))=2=r1;
 * 距离（P,C2）=Math.sqrt((2-5)*(2-5)+(0,0)*(0,0))=3=d-r2;
 * 
 * 
 */
 function getCalculatingDistance(x1,y1,x2,y2,r1,r2){
      var d=Math.sqrt((x2-x1)*(x2-x1)+(y2-y1)*(y2-y1));
      var X1=x1+r1*(x2-x1)/d,Y1=y1+r1*(y2-y1)/d,
      X2=x2-r2*(x2-x1)/d,Y2=y2-r2*(y2-y1)/d,
      X3=x2+r2*(x2-x1)/d,Y3=y2+r2*(y2-y1)/d;
      var arr={d,X1,Y1,X2,Y2,X3,Y3};
      return arr;
    };
// 矩形等去角 连线函数
function creatmyHangClipGap(area, param) {
  console.log("是否调用此函数creatOneCorner（）");
  console.log("是否调用此函数creatOneCorner（）param=", param);
  var xa = param.xa, ya = param.ya, xb = param.xb, 
  yb = param.yb, xc = param.xc, 
  yc = param.yc, xg = param.xg, yg = param.yg, 
  xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf,glassH=param.glassH,glassW=param.glassW, 
  xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,  
  x = param.x0,y = param.y0, r = param.r, rd = param.rd,w = param.w,w1 = param.w1,h1 = param.h1, h = param.h,d = param.d,
  hrd= param.hrd,o1r= param.o1r,cutLine=param.cutLine,cutFilletRadius=param.cutFilletRadius,glassH=param.glassH,glassW=param.glassW,
  oAddn= param.oAddn,oAX1dn= param.oAX1dn,oAY1dn= param.oAY1dn,oAX2dn= param.oAX2dn,oAY2dn= param.oAY2dn,oAX3dn= param.oAX3dn,oAY3dn= param.oAY3dn,
  oBddn= param.oBddn,oBX1dn= param.oBX1dn,oBY1dn= param.oBY1dn,oBX2dn= param.oBX2dn,oBY2dn= param.oBY2dn,oBX3dn= param.oBX3dn,oBY3dn= param.oBY3dn,
  oCddn= param.oCddn,oCX1dn= param.oCX1dn,oCY1dn= param.oCY1dn,oCX2dn= param.oCX2dn,oCY2dn= param.oCY2dn,oCX3dn= param.oCX3dn,oCY3dn= param.oCY3dn,
  oDddn= param.oDddn,oDX1dn= param.oDX1dn,oDY1dn= param.oDY1dn,oDX2dn= param.oDX2dn,oDY2dn= param.oDY2dn,oDX3dn= param.oDX3dn,oDY3dn= param.oDY3dn,
  oFddn= param.oFddn,oFX1dn= param.oFX1dn,oFY1dn= param.oFY1dn,oFX2dn= param.oFX2dn,oFY2dn= param.oFY2dn,oFX3dn= param.oFX3dn,oFY3dn= param.oFY3dn,
  oGddn= param.oGddn,oGX1dn= param.oGX1dn,oGY1dn= param.oGY1dn,oGX2dn= param.oGX2dn,oGY2dn= param.oGY2dn,oGX3dn= param.oGX3dn,oGY3dn= param.oGY3dn,
  oHddn= param.oHddn,oHX1dn= param.oHX1dn,oHY1dn= param.oHY1dn,oHX2dn= param.oHX2dn,oHY2dn= param.oHY2dn,oHX3dn= param.oHX3dn,oHY3dn= param.oHY3dn,
  oIddn= param.oIddn,oIX1dn= param.oIX1dn,oIY1dn= param.oIY1dn,oIX2dn= param.oIX2dn,oIY2dn= param.oIY2dn,oIX3dn= param.oIX3dn,oIY3dn= param.oIY3dn,
  oAdup= param.oAdup,oAX1up= param.oAX1up,oAY1up= param.oAY1up,oAX2up= param.oAX2up,oAY2up= param.oAY2up,oAX3up= param.oAX3up,oAY3up= param.oAY3up,
  oBdup= param.oBdup,oBX1up= param.oBX1up,oBY1up= param.oBY1up,oBX2up= param.oBX2up,oBY2up= param.oBY2up,oBX3up= param.oBX3up,oBY3up= param.oBY3up,
  oCdup= param.oCdup,oCX1up= param.oCX1up,oCY1up= param.oCY1up,oCX2up= param.oCX2up,oCY2up= param.oCY2up,oCX3up= param.oCX3up,oCY3up= param.oCY3up,
  oDdup= param.oDdup,oDX1up= param.oDX1up,oDY1up= param.oDY1up,oDX2up= param.oDX2up,oDY2up= param.oDY2up,oDX3up= param.oDX3up,oDY3up= param.oDY3up,
  oFdup= param.oFdup,oFX1up= param.oFX1up,oFY1up= param.oFY1up,oFX2up= param.oFX2up,oFY2up= param.oFY2up,oFX3up= param.oFX3up,oFY3up= param.oFY3up,
  oGdup= param.oGdup,oGX1up= param.oGX1up,oGY1up= param.oGY1up,oGX2up= param.oGX2up,oGY2up= param.oGY2up,oGX3up= param.oGX3up,oGY3up= param.oGY3up,
  oHdup= param.oHdup,oHX1up= param.oHX1up,oHY1up= param.oHY1up,oHX2up= param.oHX2up,oHY2up= param.oHY2up,oHX3up= param.oHX3up,oHY3up= param.oHY3up,
  oIdup= param.oIdup,oIX1up= param.oIX1up,oIY1up= param.oIY1up,oIX2up= param.oIX2up,oIY2up= param.oIY2up,oIX3up= param.oIX3up,oIY3up= param.oIY3up; 
  var od=(w1-w)/2;//差值
  if(glassW*1<glassH * 1){
      console.log("长边在X轴￥￥￥￥￥");
      if (area == "A") {
            var myHangClipGap= {
              paths: {
                    "TopArcA": new makerjs.paths.Arc([xa,ya], [xa+h,ya-w/2],[xa,ya-w]),
                    "LeftHolesA": new makerjs.paths.Circle([xa+h1, ya+od], r),
                    "RightHolesA":new makerjs.paths.Circle([xa+h1,ya-w-od], r),
                  }
            };
            //添加引爆槽和出入刀线
            var myHangClipGapCut = {
              paths: {
                    "EntryLineA":new makerjs.paths.Line([xa,ya-w-cutLine], [xa,ya-w]),  //入刀线     
                  //   "BigArcAdn": new makerjs.paths.Line([xa,ya-w],[oAX1dn, oAY1dn]),  
                    "BigArcAdn": new makerjs.paths.Arc([xa,ya-w],[oAX1dn, oAY1dn], o1r,false,false),   
                    "ExpSlotALineEnDn":new makerjs.paths.Line([oAX1dn, oAY1dn], [oAX2dn, oAY2dn]), //引爆槽 线入
                    "DownHolesA": new makerjs.paths.Circle([oAX2dn, oAY2dn], [oAX3dn, oAY3dn]),//下方孔
                    "ExpSlotALineExDn":new makerjs.paths.Line([oAX2dn, oAY2dn], [oAX1dn, oAY1dn]), //引爆槽 线出
                    "BigArcAmid": new makerjs.paths.Arc([oAX1dn, oAY1dn],[oAX1up, oAY1up], o1r,false,false), 
                    "ExpSlotALineEnUp":new makerjs.paths.Line([oAX1up, oAY1up], [oAX2up, oAY2up]), //引爆槽 线入
                    "UpHolesA":new makerjs.paths.Circle([oAX2up, oAY2up], [oAX3up, oAY3up]),//上方孔
                    "ExpSlotALineExUp":new makerjs.paths.Line([oAX2up, oAY2up], [oAX1up, oAY1up]), //引爆槽 线出      
                    "BigArcAup": new makerjs.paths.Arc([oAX1up, oAY1up],[xa,ya], o1r,false,false),
                    "ExitLineA":new makerjs.paths.Line([xa,ya], [xa,ya+cutLine]), //出刀线
                  }
            };   
            //添加引爆槽和出入刀线以及圆角
            var myHangClipGapWaterCut = {
                  paths: {
                        "EntryLineA":new makerjs.paths.Line([xa,ya-w-cutLine], [xa,ya-w]),  //入刀线   
                        "BigArcAdn": new makerjs.paths.Arc([xa,ya-w],[oAX1dn, oAY1dn], o1r,false,false),   
                        "ExpSlotALineEnDn":new makerjs.paths.Line([oAX1dn, oAY1dn], [oAX2dn, oAY2dn]), //引爆槽 线入
                        "DownHolesUpA": new makerjs.paths.Arc([oAX2dn, oAY2dn], [oAX3dn, oAY3dn], r,false,false),//下方孔
                        "DownHolesDnA": new makerjs.paths.Arc([oAX3dn, oAY3dn],[oAX2dn, oAY2dn],  r,false,false),//下方孔
                        "ExpSlotALineExDn":new makerjs.paths.Line([oAX2dn, oAY2dn], [oAX1dn, oAY1dn]), //引爆槽 线出
                        "BigArcAmid": new makerjs.paths.Arc([oAX1dn, oAY1dn],[oAX1up, oAY1up], o1r,false,false), 
                        "ExpSlotALineEnUp":new makerjs.paths.Line([oAX1up, oAY1up], [oAX2up, oAY2up]), //引爆槽 线入
                        "UpHolesUpA":new makerjs.paths.Arc([oAX2up, oAY2up], [oAX3up, oAY3up], r,false,false),//上方孔
                        "UpHolesDnA":new makerjs.paths.Arc([oAX3up, oAY3up],[oAX2up, oAY2up], r,false,false),//上方孔
                        "ExpSlotALineExUp":new makerjs.paths.Line([oAX2up, oAY2up], [oAX1up, oAY1up]), //引爆槽 线出      
                        "BigArcAup": new makerjs.paths.Arc([oAX1up, oAY1up],[xa,ya], o1r,false,false),
                        "ExitLineA":new makerjs.paths.Line([xa,ya], [xa,ya+cutLine]), //出刀线
                      }
                };            
                var fillet1 = makerjs.path.fillet(myHangClipGapWaterCut.paths.EntryLineA, myHangClipGapWaterCut.paths.BigArcAdn, cutFilletRadius);
                var fillet2 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcAdn, myHangClipGapWaterCut.paths.ExpSlotALineEnDn, cutFilletRadius);
                var fillet3 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotALineEnDn, myHangClipGapWaterCut.paths.DownHolesUpA, cutFilletRadius);
                var fillet4 = makerjs.path.fillet(myHangClipGapWaterCut.paths.DownHolesDnA, myHangClipGapWaterCut.paths.ExpSlotALineExDn, cutFilletRadius);
                var fillet5 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotALineExDn, myHangClipGapWaterCut.paths.BigArcAmid, cutFilletRadius);
                var fillet6 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcAmid, myHangClipGapWaterCut.paths.ExpSlotALineEnUp, cutFilletRadius);
                var fillet7 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotALineEnUp, myHangClipGapWaterCut.paths.UpHolesUpA, cutFilletRadius);
                var fillet8 = makerjs.path.fillet(myHangClipGapWaterCut.paths.UpHolesDnA, myHangClipGapWaterCut.paths.ExpSlotALineExUp, cutFilletRadius);
                var fillet9 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotALineExUp, myHangClipGapWaterCut.paths.BigArcAup, cutFilletRadius);
                var fillet10 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcAup, myHangClipGapWaterCut.paths.ExitLineA, cutFilletRadius);
                myHangClipGapWaterCut.paths.fillet1 = fillet1;
                myHangClipGapWaterCut.paths.fillet2 = fillet2;
                myHangClipGapWaterCut.paths.fillet3 = fillet3;
                myHangClipGapWaterCut.paths.fillet4 = fillet4;
                myHangClipGapWaterCut.paths.fillet5 = fillet5;
                myHangClipGapWaterCut.paths.fillet6 = fillet6;
                myHangClipGapWaterCut.paths.fillet7 = fillet7;
                myHangClipGapWaterCut.paths.fillet8 = fillet8;
                myHangClipGapWaterCut.paths.fillet9 = fillet9;
                myHangClipGapWaterCut.paths.fillet10 = fillet10;
          } else if (area == "C") {              
            var myHangClipGap = {
              paths: {
                "TopArcC": new makerjs.paths.Arc([xc,yc], [xc-h,yc-w/2],[xc,yc-w]),
                "LeftHolesC": new makerjs.paths.Circle([xc-h1, yc+od], r),
                "RightHolesC":new makerjs.paths.Circle([xc-h1,yc-w-od], r),
                  }
            };              
            var myHangClipGapWaterCut = {
              paths: {
                  "EntryLineC":new makerjs.paths.Line([xc,yc+cutLine], [xc,yc]),  //入刀线       
                  "BigArcCup": new makerjs.paths.Arc([xc,yc],[oCX1dn, oCY1dn], o1r,false,false),  
                  "ExpSlotCLineEnUp":new makerjs.paths.Line([oCX1dn, oCY1dn], [oCX2dn, oCY2dn]), //引爆槽 线入
                  "UpHolesUpC":new makerjs.paths.Arc([oCX2dn, oCY2dn], [oCX3dn, oCY3dn], r,false,false),//上方孔
                  "UpHolesDnC":new makerjs.paths.Arc([oCX3dn, oCY3dn],[oCX2dn, oCY2dn], r,false,false),//上方孔
                  "ExpSlotCLineExUp":new makerjs.paths.Line([oCX2dn, oCY2dn], [oCX1dn, oCY1dn]), //引爆槽 线出  
                  "BigArcCmid": new makerjs.paths.Arc([oCX1dn, oCY1dn],[oCX1up, oCY1up], o1r,false,false), 
                  "ExpSlotCLineEnDn":new makerjs.paths.Line([oCX1up, oCY1up], [oCX2up, oCY2up]), //引爆槽 线入
                  "DownHolesUpC": new makerjs.paths.Arc([oCX2up, oCY2up], [oCX3up, oCY3up], r,false,false),//下方孔
                  "DownHolesDnC": new makerjs.paths.Arc([oCX3up, oCY3up],[oCX2up, oCY2up], r,false,false),//下方孔
                  "ExpSlotCLineExDn":new makerjs.paths.Line([oCX2up, oCY2up], [oCX1up, oCY1up]), //引爆槽 线出
                  "BigArcCdn": new makerjs.paths.Arc([oCX1up, oCY1up],[xc,yc-w], o1r,false,false),   
                  "ExitLineC":new makerjs.paths.Line([xc,yc-w], [xc,yc-w-cutLine]), //出刀线
                  }
            };            
            var fillet1 = makerjs.path.fillet(myHangClipGapWaterCut.paths.EntryLineC, myHangClipGapWaterCut.paths.BigArcCup, cutFilletRadius);
            var fillet2 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcCup, myHangClipGapWaterCut.paths.ExpSlotCLineEnUp, cutFilletRadius);
            var fillet3 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotCLineEnUp, myHangClipGapWaterCut.paths.UpHolesUpC, cutFilletRadius);
            var fillet4 = makerjs.path.fillet(myHangClipGapWaterCut.paths.UpHolesDnC, myHangClipGapWaterCut.paths.ExpSlotCLineExUp, cutFilletRadius);
            var fillet5 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotCLineExUp, myHangClipGapWaterCut.paths.BigArcCmid, cutFilletRadius);
            var fillet6 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcCmid, myHangClipGapWaterCut.paths.ExpSlotCLineEnDn, cutFilletRadius);
            var fillet7 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotCLineEnDn, myHangClipGapWaterCut.paths.DownHolesUpC, cutFilletRadius);
            var fillet8 = makerjs.path.fillet(myHangClipGapWaterCut.paths.DownHolesDnC, myHangClipGapWaterCut.paths.ExpSlotCLineExDn, cutFilletRadius);
            var fillet9 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotCLineExDn, myHangClipGapWaterCut.paths.BigArcCdn, cutFilletRadius);
            var fillet10 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcCdn, myHangClipGapWaterCut.paths.ExitLineC, cutFilletRadius);
            myHangClipGapWaterCut.paths.fillet1 = fillet1;
            myHangClipGapWaterCut.paths.fillet2 = fillet2;
            myHangClipGapWaterCut.paths.fillet3 = fillet3;
            myHangClipGapWaterCut.paths.fillet4 = fillet4;
            myHangClipGapWaterCut.paths.fillet5 = fillet5;
            myHangClipGapWaterCut.paths.fillet6 = fillet6;
            myHangClipGapWaterCut.paths.fillet7 = fillet7;
            myHangClipGapWaterCut.paths.fillet8 = fillet8;
            myHangClipGapWaterCut.paths.fillet9 = fillet9;
            myHangClipGapWaterCut.paths.fillet10 = fillet10;
          } else if (area == "D") {
              
            var myHangClipGap = {
              paths: {
                "TopArcD": new makerjs.paths.Arc([xd,yd+w/2], [xd+h,yd],[xd,yd-w/2]),
                "LeftHolesD": new makerjs.paths.Circle([xd+h1, yd+od+w/2], r),
                "RightHolesD":new makerjs.paths.Circle([xd+h1,yd-w/2-od], r),
                  }
            };
              
            var myHangClipGapWaterCut = {
              paths: {
                  "EntryLineD":new makerjs.paths.Line([xd,yd-w/2-cutLine], [xd,yd-w/2]),  //入刀线      
                  "BigArcDdn": new makerjs.paths.Arc([xd,yd-w/2],[oDX1dn, oDY1dn], o1r,false,false),   
                  "ExpSlotDLineEnDn":new makerjs.paths.Line([oDX1dn, oDY1dn], [oDX2dn, oDY2dn]), //引爆槽 线入
                  "DownHolesUpD": new makerjs.paths.Arc([oDX2dn, oDY2dn], [oDX3dn, oDY3dn], r,false,false),//下方孔
                  "DownHolesDnD": new makerjs.paths.Arc([oDX3dn, oDY3dn],[oDX2dn, oDY2dn],  r,false,false),//下方孔
                  "ExpSlotDLineExDn":new makerjs.paths.Line([oDX2dn, oDY2dn], [oDX1dn, oDY1dn]), //引爆槽 线出 
                  "BigArcDmid": new makerjs.paths.Arc([oDX1dn, oDY1dn],[oDX1up, oDY1up], o1r,false,false),  
                  "ExpSlotDLineEnUp":new makerjs.paths.Line([oDX1up, oDY1up], [oDX2up, oDY2up]), //引爆槽 线入
                  "UpHolesUpD":new makerjs.paths.Arc([oDX2up, oDY2up], [oDX3up, oDY3up], r,false,false),//上方孔
                  "UpHolesDnD":new makerjs.paths.Arc([oDX3up, oDY3up],[oDX2up, oDY2up],r,false,false),//上方孔
                  "ExpSlotDLineExUp":new makerjs.paths.Line([oDX2up, oDY2up], [oDX1up, oDY1up]), //引爆槽 线出   
                  "BigArcDup": new makerjs.paths.Arc([oDX1up, oDY1up], [xd,yd+w/2],o1r,false,false),
                  "ExitLineD":new makerjs.paths.Line([xd,yd+w/2], [xd,yd+w/2+cutLine]), //出刀线
                  }
            };           
            var fillet1 = makerjs.path.fillet(myHangClipGapWaterCut.paths.EntryLineD, myHangClipGapWaterCut.paths.BigArcDdn, cutFilletRadius);
            var fillet2 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcDdn, myHangClipGapWaterCut.paths.ExpSlotDLineEnDn, cutFilletRadius);
            var fillet3 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotDLineEnDn, myHangClipGapWaterCut.paths.DownHolesUpD, cutFilletRadius);
            var fillet4 = makerjs.path.fillet(myHangClipGapWaterCut.paths.DownHolesDnD, myHangClipGapWaterCut.paths.ExpSlotDLineExDn, cutFilletRadius);
            var fillet5 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotDLineExDn, myHangClipGapWaterCut.paths.BigArcDmid, cutFilletRadius);
            var fillet6 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcDmid, myHangClipGapWaterCut.paths.ExpSlotDLineEnUp, cutFilletRadius);
            var fillet7 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotDLineEnUp, myHangClipGapWaterCut.paths.UpHolesUpD, cutFilletRadius);
            var fillet8 = makerjs.path.fillet(myHangClipGapWaterCut.paths.UpHolesDnD, myHangClipGapWaterCut.paths.ExpSlotDLineExUp, cutFilletRadius);
            var fillet9 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotDLineExUp, myHangClipGapWaterCut.paths.BigArcDup, cutFilletRadius);
            var fillet10 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcDup, myHangClipGapWaterCut.paths.ExitLineD, cutFilletRadius);
            myHangClipGapWaterCut.paths.fillet1 = fillet1;
            myHangClipGapWaterCut.paths.fillet2 = fillet2;
            myHangClipGapWaterCut.paths.fillet3 = fillet3;
            myHangClipGapWaterCut.paths.fillet4 = fillet4;
            myHangClipGapWaterCut.paths.fillet5 = fillet5;
            myHangClipGapWaterCut.paths.fillet6 = fillet6;
            myHangClipGapWaterCut.paths.fillet7 = fillet7;
            myHangClipGapWaterCut.paths.fillet8 = fillet8;
            myHangClipGapWaterCut.paths.fillet9 = fillet9;
            myHangClipGapWaterCut.paths.fillet10 = fillet10;
          } else if (area == "F") {
              var myHangClipGap = {
                    paths: {  
                      "TopArcF": new makerjs.paths.Arc([xf,yf+w/2], [xf-h,yf],[xf,yf-w/2]),
                      "LeftHolesF": new makerjs.paths.Circle([xf-h1, yf+od+w/2], r),
                      "RightHolesF":new makerjs.paths.Circle([xf-h1,yf-w/2-od], r),
                        }
                  };
                    
            var myHangClipGapWaterCut = {
                  paths: {
                      "EntryLineF":new makerjs.paths.Line([xf,yf+w/2+cutLine], [xf,yf+w/2]),  //入刀线     
                      "BigArcFup": new makerjs.paths.Arc([xf,yf+w/2],[oFX1up, oFY1up], o1r,false,false),  
                      "ExpSlotFLineEnUp":new makerjs.paths.Line([oFX1up, oFY1up], [oFX2up, oFY2up]), //引爆槽 线入
                      "UpHolesUpF":new makerjs.paths.Arc([oFX2up, oFY2up], [oFX3up, oFY3up],r,false,false),//上方孔
                      "UpHolesDnF":new makerjs.paths.Arc([oFX3up, oFY3up],[oFX2up, oFY2up], r,false,false),//上方孔
                      "ExpSlotFLineExUp":new makerjs.paths.Line([oFX2up, oFY2up], [oFX1up, oFY1up]), //引爆槽 线出 
                      "BigArcFmid": new makerjs.paths.Arc([oFX1up, oFY1up], [oFX1dn, oFY1dn],o1r,false,false), 
                      "ExpSlotFLineEnDn":new makerjs.paths.Line([oFX1dn, oFY1dn], [oFX2dn, oFY2dn]), //引爆槽 线入
                      "DownHolesUpF": new makerjs.paths.Arc([oFX2dn, oFY2dn], [oFX3dn, oFY3dn],r,false,false),//下方孔
                      "DownHolesDnF": new makerjs.paths.Arc([oFX3dn, oFY3dn],[oFX2dn, oFY2dn], r,false,false),//下方孔
                      "ExpSlotFLineExDn":new makerjs.paths.Line([oFX2dn, oFY2dn], [oFX1dn, oFY1dn]), //引爆槽 线出    
                      "BigArcFdn": new makerjs.paths.Arc([oFX1dn, oFY1dn], [xf,yf-w/2],o1r,false,false),  
                      "ExitLineF":new makerjs.paths.Line([xf,yf-w/2], [xf,yf-w/2-cutLine]), //出刀线
                      }
                };           
                var fillet1 = makerjs.path.fillet(myHangClipGapWaterCut.paths.EntryLineF, myHangClipGapWaterCut.paths.BigArcFup, cutFilletRadius);
                var fillet2 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcFup, myHangClipGapWaterCut.paths.ExpSlotFLineEnUp, cutFilletRadius);
                var fillet3 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotFLineEnUp, myHangClipGapWaterCut.paths.UpHolesUpF, cutFilletRadius);
                var fillet4 = makerjs.path.fillet(myHangClipGapWaterCut.paths.UpHolesDnF, myHangClipGapWaterCut.paths.ExpSlotFLineExUp, cutFilletRadius);
                var fillet5 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotFLineExUp, myHangClipGapWaterCut.paths.BigArcFmid, cutFilletRadius);
                var fillet6 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcFmid, myHangClipGapWaterCut.paths.ExpSlotFLineEnDn, cutFilletRadius);
                var fillet7 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotFLineEnDn, myHangClipGapWaterCut.paths.DownHolesUpF, cutFilletRadius);
                var fillet8 = makerjs.path.fillet(myHangClipGapWaterCut.paths.DownHolesDnF, myHangClipGapWaterCut.paths.ExpSlotFLineExDn, cutFilletRadius);
                var fillet9 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotFLineExDn, myHangClipGapWaterCut.paths.BigArcFdn, cutFilletRadius);
                var fillet10 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcFdn, myHangClipGapWaterCut.paths.ExitLineF, cutFilletRadius);
                myHangClipGapWaterCut.paths.fillet1 = fillet1;
                myHangClipGapWaterCut.paths.fillet2 = fillet2;
                myHangClipGapWaterCut.paths.fillet3 = fillet3;
                myHangClipGapWaterCut.paths.fillet4 = fillet4;
                myHangClipGapWaterCut.paths.fillet5 = fillet5;
                myHangClipGapWaterCut.paths.fillet6 = fillet6;
                myHangClipGapWaterCut.paths.fillet7 = fillet7;
                myHangClipGapWaterCut.paths.fillet8 = fillet8;
                myHangClipGapWaterCut.paths.fillet9 = fillet9;
                myHangClipGapWaterCut.paths.fillet10 = fillet10;
              } else if (area == "G") {
              var myHangClipGap = {
                    paths: {
                      "TopArcG": new makerjs.paths.Arc([xg,yg], [xg+h,yg+w/2],[xg,yg+w]),
                      "LeftHolesG": new makerjs.paths.Circle([xg+h1, yg-od], r),
                      "RightHolesG":new makerjs.paths.Circle([xg+h1,yg+w+od], r),
                        }
                  };
               
            var myHangClipGapWaterCut = {
                  paths: {
                      "EntryLineG":new makerjs.paths.Line([xg,yg-cutLine], [xg,yg]),  //入刀线      
                      "BigArcGdn": new makerjs.paths.Arc([xg,yg],[oGX1dn, oGY1dn], o1r,false,false),   
                      "ExpSlotGLineEnDn":new makerjs.paths.Line([oGX1dn, oGY1dn], [oGX2dn, oGY2dn]), //引爆槽 线入
                      "DownHolesUpG": new makerjs.paths.Arc([oGX2dn, oGY2dn], [oGX3dn, oGY3dn], r,false,false),//下方孔
                      "DownHolesDnG": new makerjs.paths.Arc([oGX3dn, oGY3dn],[oGX2dn, oGY2dn], r,false,false),//下方孔
                      "ExpSlotGLineExDn":new makerjs.paths.Line([oGX2dn, oGY2dn], [oGX1dn, oGY1dn]), //引爆槽 线出 
                      "BigArcGmid": new makerjs.paths.Arc([oGX1dn, oGY1dn],[oGX1up, oGY1up], o1r,false,false),  
                      "ExpSlotGLineEnUp":new makerjs.paths.Line([oGX1up, oGY1up], [oGX2up, oGY2up]), //引爆槽 线入
                      "UpHolesUpG":new makerjs.paths.Arc([oGX2up, oGY2up], [oGX3up, oGY3up], r,false,false),//上方孔
                      "UpHolesDnG":new makerjs.paths.Arc([oGX3up, oGY3up],[oGX2up, oGY2up], r,false,false),//上方孔
                      "ExpSlotGLineExUp":new makerjs.paths.Line([oGX2up, oGY2up], [oGX1up, oGY1up]), //引爆槽 线出   
                      "BigArcGup": new makerjs.paths.Arc([oGX1up, oGY1up], [xg,yg+w],o1r,false,false),
                      "ExitLineG":new makerjs.paths.Line([xg,yg+w], [xg,yg+w+cutLine]), //出刀线
                      }
                };           
                var fillet1 = makerjs.path.fillet(myHangClipGapWaterCut.paths.EntryLineG, myHangClipGapWaterCut.paths.BigArcGdn, cutFilletRadius);
                var fillet2 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcGdn, myHangClipGapWaterCut.paths.ExpSlotGLineEnDn, cutFilletRadius);
                var fillet3 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotGLineEnDn, myHangClipGapWaterCut.paths.DownHolesUpG, cutFilletRadius);
                var fillet4 = makerjs.path.fillet(myHangClipGapWaterCut.paths.DownHolesDnG, myHangClipGapWaterCut.paths.ExpSlotGLineExDn, cutFilletRadius);
                var fillet5 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotGLineExDn, myHangClipGapWaterCut.paths.BigArcGmid, cutFilletRadius);
                var fillet6 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcGmid, myHangClipGapWaterCut.paths.ExpSlotGLineEnUp, cutFilletRadius);
                var fillet7 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotGLineEnUp, myHangClipGapWaterCut.paths.UpHolesUpG, cutFilletRadius);
                var fillet8 = makerjs.path.fillet(myHangClipGapWaterCut.paths.UpHolesDnG, myHangClipGapWaterCut.paths.ExpSlotGLineExUp, cutFilletRadius);
                var fillet9 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotGLineExUp, myHangClipGapWaterCut.paths.BigArcGup, cutFilletRadius);
                var fillet10 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcGup, myHangClipGapWaterCut.paths.ExitLineG, cutFilletRadius);
                myHangClipGapWaterCut.paths.fillet1 = fillet1;
                myHangClipGapWaterCut.paths.fillet2 = fillet2;
                myHangClipGapWaterCut.paths.fillet3 = fillet3;
                myHangClipGapWaterCut.paths.fillet4 = fillet4;
                myHangClipGapWaterCut.paths.fillet5 = fillet5;
                myHangClipGapWaterCut.paths.fillet6 = fillet6;
                myHangClipGapWaterCut.paths.fillet7 = fillet7;
                myHangClipGapWaterCut.paths.fillet8 = fillet8;
                myHangClipGapWaterCut.paths.fillet9 = fillet9;
                myHangClipGapWaterCut.paths.fillet10 = fillet10;
              } else if (area == "I") {
           var myHangClipGap = {
              paths: {
                "TopArcI": new makerjs.paths.Arc([xi,yi], [xi-h,yi+w/2],[xi,yi+w]),
                "LeftHolesI": new makerjs.paths.Circle([xi-h1, yi-od], r),
                "RightHolesI":new makerjs.paths.Circle([xi-h1,yi+w+od], r),
              }
        };     
        var myHangClipGapWaterCut = {
              paths: {
                  "EntryLineI":new makerjs.paths.Line([xi,yi+w+cutLine], [xi,yi+w]),  //入刀线     
                  "BigArcIup": new makerjs.paths.Arc([xi,yi+w],[oIX1up, oIY1up], o1r,false,false),  
                  "ExpSlotILineEnUp":new makerjs.paths.Line([oIX1up, oIY1up], [oIX2up, oIY2up]), //引爆槽 线入
                  "UpHolesUpI":new makerjs.paths.Arc([oIX2up, oIY2up], [oIX3up, oIY3up],r,false,false),//上方孔
                  "UpHolesDnI":new makerjs.paths.Arc([oIX3up, oIY3up],[oIX2up, oIY2up], r,false,false),//上方孔
                  "ExpSlotILineExUp":new makerjs.paths.Line([oIX2up, oIY2up], [oIX1up, oIY1up]), //引爆槽 线出 
                  "BigArcImid": new makerjs.paths.Arc([oIX1up, oIY1up], [oIX1dn, oIY1dn],o1r,false,false), 
                  "ExpSlotILineEnDn":new makerjs.paths.Line([oIX1dn, oIY1dn], [oIX2dn, oIY2dn]), //引爆槽 线入
                  "DownHolesUpI": new makerjs.paths.Arc([oIX2dn, oIY2dn], [oIX3dn, oIY3dn],r,false,false),//下方孔
                  "DownHolesDnI": new makerjs.paths.Arc([oIX3dn, oIY3dn],[oIX2dn, oIY2dn], r,false,false),//下方孔
                  "ExpSlotILineExDn":new makerjs.paths.Line([oIX2dn, oIY2dn], [oIX1dn, oIY1dn]), //引爆槽 线出    
                  "BigArcIdn": new makerjs.paths.Arc([oIX1dn, oIY1dn], [xi,yi],o1r,false,false),  
                  "ExitLineI":new makerjs.paths.Line([xi,yi], [xi,yi-cutLine]), //出刀线
                  }
            };           
            var fillet1 = makerjs.path.fillet(myHangClipGapWaterCut.paths.EntryLineI, myHangClipGapWaterCut.paths.BigArcIup, cutFilletRadius);
            var fillet2 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcIup, myHangClipGapWaterCut.paths.ExpSlotILineEnUp, cutFilletRadius);
            var fillet3 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotILineEnUp, myHangClipGapWaterCut.paths.UpHolesUpI, cutFilletRadius);
            var fillet4 = makerjs.path.fillet(myHangClipGapWaterCut.paths.UpHolesDnI, myHangClipGapWaterCut.paths.ExpSlotILineExUp, cutFilletRadius);
            var fillet5 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotILineExUp, myHangClipGapWaterCut.paths.BigArcImid, cutFilletRadius);
            var fillet6 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcImid, myHangClipGapWaterCut.paths.ExpSlotILineEnDn, cutFilletRadius);
            var fillet7 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotILineEnDn, myHangClipGapWaterCut.paths.DownHolesUpI, cutFilletRadius);
            var fillet8 = makerjs.path.fillet(myHangClipGapWaterCut.paths.DownHolesDnI, myHangClipGapWaterCut.paths.ExpSlotILineExDn, cutFilletRadius);
            var fillet9 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotILineExDn, myHangClipGapWaterCut.paths.BigArcIdn, cutFilletRadius);
            var fillet10 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcIdn, myHangClipGapWaterCut.paths.ExitLineI, cutFilletRadius);
            myHangClipGapWaterCut.paths.fillet1 = fillet1;
            myHangClipGapWaterCut.paths.fillet2 = fillet2;
            myHangClipGapWaterCut.paths.fillet3 = fillet3;
            myHangClipGapWaterCut.paths.fillet4 = fillet4;
            myHangClipGapWaterCut.paths.fillet5 = fillet5;
            myHangClipGapWaterCut.paths.fillet6 = fillet6;
            myHangClipGapWaterCut.paths.fillet7 = fillet7;
            myHangClipGapWaterCut.paths.fillet8 = fillet8;
            myHangClipGapWaterCut.paths.fillet9 = fillet9;
            myHangClipGapWaterCut.paths.fillet10 = fillet10;
          }
}else{
      console.log("短边在X轴￥￥￥￥￥");
      if (area == "A") {
        var myHangClipGap = {
          paths: {
                "TopArcA": new makerjs.paths.Arc([xa,ya], [xa+w/2,ya-h],[xa+w,ya]),
                "LeftHolesA": new makerjs.paths.Circle([xa-od, ya-h1], r),
                "RightHolesA":new makerjs.paths.Circle([xa+w+od,ya-h1], r),
              }
        };
     
            //添加引爆槽和出入刀线
            var myHangClipGapWaterCut = {
                  paths: {
                        "EntryLineA":new makerjs.paths.Line([xa-cutLine,ya], [xa,ya]),  //入刀线      
                        "BigArcAdn": new makerjs.paths.Arc([xa,ya],[oAX1dn, oAY1dn], o1r,false,false),  
                        "ExpSlotALineEnDn":new makerjs.paths.Line([oAX1dn, oAY1dn], [oAX2dn, oAY2dn]), //引爆槽 线入
                        "DownHolesUpA": new makerjs.paths.Arc([oAX2dn, oAY2dn], [oAX3dn, oAY3dn], r,false,false),//下方孔
                        "DownHolesDnA": new makerjs.paths.Arc([oAX3dn, oAY3dn],[oAX2dn, oAY2dn],  r,false,false),//下方孔
                        "ExpSlotALineExDn":new makerjs.paths.Line([oAX2dn, oAY2dn], [oAX1dn, oAY1dn]), //引爆槽 线出
                        "BigArcAmid": new makerjs.paths.Arc([oAX1dn, oAY1dn],[oAX1up, oAY1up], o1r,false,false), 
                        "ExpSlotALineEnUp":new makerjs.paths.Line([oAX1up, oAY1up], [oAX2up, oAY2up]), //引爆槽 线入
                        "UpHolesUpA":new makerjs.paths.Arc([oAX2up, oAY2up], [oAX3up, oAY3up], r,false,false),//上方孔
                        "UpHolesDnA":new makerjs.paths.Arc([oAX3up, oAY3up],[oAX2up, oAY2up],  r,false,false),//上方孔
                        "ExpSlotALineExUp":new makerjs.paths.Line([oAX2up, oAY2up], [oAX1up, oAY1up]), //引爆槽 线出      
                        "BigArcAup": new makerjs.paths.Arc([oAX1up, oAY1up],[xa+w,ya], o1r,false,false),
                        "ExitLineA":new makerjs.paths.Line([xa+w,ya], [xa+w+cutLine,ya]), //出刀线
                      }
                };           
                var fillet1 = makerjs.path.fillet(myHangClipGapWaterCut.paths.EntryLineA, myHangClipGapWaterCut.paths.BigArcAdn, cutFilletRadius);
                var fillet2 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcAdn, myHangClipGapWaterCut.paths.ExpSlotALineEnDn, cutFilletRadius);
                var fillet3 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotALineEnDn, myHangClipGapWaterCut.paths.DownHolesUpA, cutFilletRadius);
                var fillet4 = makerjs.path.fillet(myHangClipGapWaterCut.paths.DownHolesDnA, myHangClipGapWaterCut.paths.ExpSlotALineExDn, cutFilletRadius);
                var fillet5 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotALineExDn, myHangClipGapWaterCut.paths.BigArcAmid, cutFilletRadius);
                var fillet6 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcAmid, myHangClipGapWaterCut.paths.ExpSlotALineEnUp, cutFilletRadius);
                var fillet7 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotALineEnUp, myHangClipGapWaterCut.paths.UpHolesUpA, cutFilletRadius);
                var fillet8 = makerjs.path.fillet(myHangClipGapWaterCut.paths.UpHolesDnA, myHangClipGapWaterCut.paths.ExpSlotALineExUp, cutFilletRadius);
                var fillet9 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotALineExUp, myHangClipGapWaterCut.paths.BigArcAup, cutFilletRadius);
                var fillet10 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcAup, myHangClipGapWaterCut.paths.ExitLineA, cutFilletRadius);
                myHangClipGapWaterCut.paths.fillet1 = fillet1;
                myHangClipGapWaterCut.paths.fillet2 = fillet2;
                myHangClipGapWaterCut.paths.fillet3 = fillet3;
                myHangClipGapWaterCut.paths.fillet4 = fillet4;
                myHangClipGapWaterCut.paths.fillet5 = fillet5;
                myHangClipGapWaterCut.paths.fillet6 = fillet6;
                myHangClipGapWaterCut.paths.fillet7 = fillet7;
                myHangClipGapWaterCut.paths.fillet8 = fillet8;
                myHangClipGapWaterCut.paths.fillet9 = fillet9;
                myHangClipGapWaterCut.paths.fillet10 = fillet10;
              
      } else if (area == "B") {              
        var myHangClipGap = {
          paths: {
                "TopArcB": new makerjs.paths.Arc([xb-w/2,yb], [xb,yb-h],[xb+w/2,yb]),
                "LeftHolesB": new makerjs.paths.Circle([xb-w/2-od, yb-h1], r),
                "RightHolesB":new makerjs.paths.Circle([xb+w/2+od,yb-h1], r),
              }
        };
     
        //添加引爆槽和出入刀线
        var myHangClipGapWaterCut = {
              paths: {
                    "EntryLineB":new makerjs.paths.Line([xb-w/2-cutLine,yb], [xb-w/2,yb]),  //入刀线      
                    "BigArcBdn": new makerjs.paths.Arc([xb-w/2,yb],[oBX1dn, oBY1dn], o1r,false,false),  
                    "ExpSlotBLineEnDn":new makerjs.paths.Line([oBX1dn, oBY1dn], [oBX2dn, oBY2dn]), //引爆槽 线入
                    "DownHolesUpB": new makerjs.paths.Arc([oBX2dn, oBY2dn], [oBX3dn, oBY3dn], r,false,false),//下方孔
                    "DownHolesDnB": new makerjs.paths.Arc([oBX3dn, oBY3dn],[oBX2dn, oBY2dn],  r,false,false),//下方孔
                    "ExpSlotBLineExDn":new makerjs.paths.Line([oBX2dn, oBY2dn], [oBX1dn, oBY1dn]), //引爆槽 线出
                    "BigArcBmid": new makerjs.paths.Arc([oBX1dn, oBY1dn],[oBX1up, oBY1up], o1r,false,false), 
                    "ExpSlotBLineEnUp":new makerjs.paths.Line([oBX1up, oBY1up], [oBX2up, oBY2up]), //引爆槽 线入
                    "UpHolesUpB":new makerjs.paths.Arc([oBX2up, oBY2up], [oBX3up, oBY3up], r,false,false),//上方孔
                    "UpHolesDnB":new makerjs.paths.Arc([oBX3up, oBY3up],[oBX2up, oBY2up],  r,false,false),//上方孔
                    "ExpSlotBLineExUp":new makerjs.paths.Line([oBX2up, oBY2up], [oBX1up, oBY1up]), //引爆槽 线出      
                    "BigArcBup": new makerjs.paths.Arc([oBX1up, oBY1up],[xb+w/2,yb], o1r,false,false),
                    "ExitLineB":new makerjs.paths.Line([xb+w/2,yb], [xb+w/2+cutLine,yb]), //出刀线
                  }
            };            
            var fillet1 = makerjs.path.fillet(myHangClipGapWaterCut.paths.EntryLineB, myHangClipGapWaterCut.paths.BigArcBdn, cutFilletRadius);
            var fillet2 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcBdn, myHangClipGapWaterCut.paths.ExpSlotBLineEnDn, cutFilletRadius);
            var fillet3 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotBLineEnDn, myHangClipGapWaterCut.paths.DownHolesUpB, cutFilletRadius);
            var fillet4 = makerjs.path.fillet(myHangClipGapWaterCut.paths.DownHolesDnB, myHangClipGapWaterCut.paths.ExpSlotBLineExDn, cutFilletRadius);
            var fillet5 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotBLineExDn, myHangClipGapWaterCut.paths.BigArcBmid, cutFilletRadius);
            var fillet6 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcBmid, myHangClipGapWaterCut.paths.ExpSlotBLineEnUp, cutFilletRadius);
            var fillet7 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotBLineEnUp, myHangClipGapWaterCut.paths.UpHolesUpB, cutFilletRadius);
            var fillet8 = makerjs.path.fillet(myHangClipGapWaterCut.paths.UpHolesDnB, myHangClipGapWaterCut.paths.ExpSlotBLineExUp, cutFilletRadius);
            var fillet9 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotBLineExUp, myHangClipGapWaterCut.paths.BigArcBup, cutFilletRadius);
            var fillet10 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcBup, myHangClipGapWaterCut.paths.ExitLineB, cutFilletRadius);
            myHangClipGapWaterCut.paths.fillet1 = fillet1;
            myHangClipGapWaterCut.paths.fillet2 = fillet2;
            myHangClipGapWaterCut.paths.fillet3 = fillet3;
            myHangClipGapWaterCut.paths.fillet4 = fillet4;
            myHangClipGapWaterCut.paths.fillet5 = fillet5;
            myHangClipGapWaterCut.paths.fillet6 = fillet6;
            myHangClipGapWaterCut.paths.fillet7 = fillet7;
            myHangClipGapWaterCut.paths.fillet8 = fillet8;
            myHangClipGapWaterCut.paths.fillet9 = fillet9;
            myHangClipGapWaterCut.paths.fillet10 = fillet10;
          
      } else if (area == "C") {
          
        var myHangClipGap = {
          paths: {
                "TopArcC": new makerjs.paths.Arc([xc,yc], [xc-w/2,yc-h],[xc-w,yc]),
                "LeftHolesC": new makerjs.paths.Circle([xc+od, yc-h1], r),
                "RightHolesC":new makerjs.paths.Circle([xc-w-od,yc-h1], r),
              }
        };
        //添加引爆槽和出入刀线
        var myHangClipGapWaterCut = {
              paths: {
                    "EntryLineC":new makerjs.paths.Line([xc-w-cutLine,yc], [xc-w,yc]),  //入刀线      
                    "BigArcCdn": new makerjs.paths.Arc([xc-w,yc],[oCX1dn, oCY1dn], o1r,false,false),  
                    "ExpSlotCLineEnDn":new makerjs.paths.Line([oCX1dn, oCY1dn], [oCX2dn, oCY2dn]), //引爆槽 线入
                    "DownHolesUpC": new makerjs.paths.Arc([oCX2dn, oCY2dn], [oCX3dn, oCY3dn], r,false,false),//下方孔
                    "DownHolesDnC": new makerjs.paths.Arc([oCX3dn, oCY3dn],[oCX2dn, oCY2dn],  r,false,false),//下方孔
                    "ExpSlotCLineExDn":new makerjs.paths.Line([oCX2dn, oCY2dn], [oCX1dn, oCY1dn]), //引爆槽 线出
                    "BigArcCmid": new makerjs.paths.Arc([oCX1dn, oCY1dn],[oCX1up, oCY1up], o1r,false,false), 
                    "ExpSlotCLineEnUp":new makerjs.paths.Line([oCX1up, oCY1up], [oCX2up, oCY2up]), //引爆槽 线入
                    "UpHolesUpC":new makerjs.paths.Arc([oCX2up, oCY2up], [oCX3up, oCY3up], r,false,false),//上方孔
                    "UpHolesDnC":new makerjs.paths.Arc([oCX3up, oCY3up],[oCX2up, oCY2up],  r,false,false),//上方孔
                    "ExpSlotCLineExUp":new makerjs.paths.Line([oCX2up, oCY2up], [oCX1up, oCY1up]), //引爆槽 线出      
                    "BigArcCup": new makerjs.paths.Arc([oCX1up, oCY1up],[xc,yc], o1r,false,false),
                    "ExitLineC":new makerjs.paths.Line([xc,yc], [xc+cutLine,yc]), //出刀线
                  }
            };             
            var fillet1 = makerjs.path.fillet(myHangClipGapWaterCut.paths.EntryLineC, myHangClipGapWaterCut.paths.BigArcCdn, cutFilletRadius);
            var fillet2 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcCdn, myHangClipGapWaterCut.paths.ExpSlotCLineEnDn, cutFilletRadius);
            var fillet3 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotCLineEnDn, myHangClipGapWaterCut.paths.DownHolesUpC, cutFilletRadius);
            var fillet4 = makerjs.path.fillet(myHangClipGapWaterCut.paths.DownHolesDnC, myHangClipGapWaterCut.paths.ExpSlotCLineExDn, cutFilletRadius);
            var fillet5 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotCLineExDn, myHangClipGapWaterCut.paths.BigArcCmid, cutFilletRadius);
            var fillet6 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcCmid, myHangClipGapWaterCut.paths.ExpSlotCLineEnUp, cutFilletRadius);
            var fillet7 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotCLineEnUp, myHangClipGapWaterCut.paths.UpHolesUpC, cutFilletRadius);
            var fillet8 = makerjs.path.fillet(myHangClipGapWaterCut.paths.UpHolesDnC, myHangClipGapWaterCut.paths.ExpSlotCLineExUp, cutFilletRadius);
            var fillet9 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotCLineExUp, myHangClipGapWaterCut.paths.BigArcCup, cutFilletRadius);
            var fillet10 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcCup, myHangClipGapWaterCut.paths.ExitLineC, cutFilletRadius);
            myHangClipGapWaterCut.paths.fillet1 = fillet1;
            myHangClipGapWaterCut.paths.fillet2 = fillet2;
            myHangClipGapWaterCut.paths.fillet3 = fillet3;
            myHangClipGapWaterCut.paths.fillet4 = fillet4;
            myHangClipGapWaterCut.paths.fillet5 = fillet5;
            myHangClipGapWaterCut.paths.fillet6 = fillet6;
            myHangClipGapWaterCut.paths.fillet7 = fillet7;
            myHangClipGapWaterCut.paths.fillet8 = fillet8;
            myHangClipGapWaterCut.paths.fillet9 = fillet9;
            myHangClipGapWaterCut.paths.fillet10 = fillet10;
            
      } else if (area == "G") {
          var myHangClipGap = {
                paths: {                         
                "TopArcG": new makerjs.paths.Arc([xg,yg], [xg+w/2,yg+h],[xg+w,yg]),
                "LeftHolesG": new makerjs.paths.Circle([xg-od, yg+h1], r),
                "RightHolesG":new makerjs.paths.Circle([xg+w+od,yg+h1], r),
                    }
              };
        
            //添加引爆槽和出入刀线
            var myHangClipGapWaterCut = {
                  paths: {
                        "EntryLineG":new makerjs.paths.Line([xg+w+cutLine,yg],[xg+w,yg]),  //入刀线       
                        "BigArcGup": new makerjs.paths.Arc([xg+w,yg],[oGX1up, oGY1up], o1r,false,false), 
                        "ExpSlotGLineEnUp":new makerjs.paths.Line([oGX1up, oGY1up], [oGX2up, oGY2up]), //引爆槽 线入
                        "UpHolesUpG":new makerjs.paths.Arc([oGX2up, oGY2up], [oGX3up, oGY3up],r,false,false),//上方孔
                        "UpHolesDnG":new makerjs.paths.Arc([oGX3up, oGY3up],[oGX2up, oGY2up], r,false,false),//上方孔
                        "ExpSlotGLineExUp":new makerjs.paths.Line([oGX2up, oGY2up], [oGX1up, oGY1up]), //引爆槽 线出  
                        "BigArcGmid": new makerjs.paths.Arc([oGX1up, oGY1up],[oGX1dn, oGY1dn], o1r,false,false),
                        "ExpSlotGLineEnDn":new makerjs.paths.Line([oGX1dn, oGY1dn], [oGX2dn, oGY2dn]), //引爆槽 线入
                        "DownHolesUpG": new makerjs.paths.Arc([oGX2dn, oGY2dn], [oGX3dn, oGY3dn], r,false,false),//下方孔
                        "DownHolesDnG": new makerjs.paths.Arc([oGX3dn, oGY3dn],[oGX2dn, oGY2dn],  r,false,false),//下方孔
                        "ExpSlotGLineExDn":new makerjs.paths.Line([oGX2dn, oGY2dn], [oGX1dn, oGY1dn]), //引爆槽 线出   
                        "BigArcGdn": new makerjs.paths.Arc([oGX1dn, oGY1dn],[xg,yg], o1r,false,false),  
                        "ExitLineG": new makerjs.paths.Line([xg,yg],[xg-cutLine,yg]),//出刀线
                      }
                };              
                var fillet1 = makerjs.path.fillet(myHangClipGapWaterCut.paths.EntryLineG, myHangClipGapWaterCut.paths.BigArcGup, cutFilletRadius);
                var fillet2 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcGup, myHangClipGapWaterCut.paths.ExpSlotGLineEnUp, cutFilletRadius);
                var fillet3 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotGLineEnUp, myHangClipGapWaterCut.paths.UpHolesUpG, cutFilletRadius);
                var fillet4 = makerjs.path.fillet(myHangClipGapWaterCut.paths.UpHolesDnG, myHangClipGapWaterCut.paths.ExpSlotGLineExUp, cutFilletRadius);
                var fillet5 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotGLineExUp, myHangClipGapWaterCut.paths.BigArcGmid, cutFilletRadius);
                var fillet6 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcGmid, myHangClipGapWaterCut.paths.ExpSlotGLineEnDn, cutFilletRadius);
                var fillet7 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotGLineEnDn, myHangClipGapWaterCut.paths.DownHolesUpG, cutFilletRadius);
                var fillet8 = makerjs.path.fillet(myHangClipGapWaterCut.paths.DownHolesDnG, myHangClipGapWaterCut.paths.ExpSlotGLineExDn, cutFilletRadius);
                var fillet9 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotGLineExDn, myHangClipGapWaterCut.paths.BigArcGdn, cutFilletRadius);
                var fillet10 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcGdn, myHangClipGapWaterCut.paths.ExitLineG, cutFilletRadius);
                myHangClipGapWaterCut.paths.fillet1 = fillet1;
                myHangClipGapWaterCut.paths.fillet2 = fillet2;
                myHangClipGapWaterCut.paths.fillet3 = fillet3;
                myHangClipGapWaterCut.paths.fillet4 = fillet4;
                myHangClipGapWaterCut.paths.fillet5 = fillet5;
                myHangClipGapWaterCut.paths.fillet6 = fillet6;
                myHangClipGapWaterCut.paths.fillet7 = fillet7;
                myHangClipGapWaterCut.paths.fillet8 = fillet8;
                myHangClipGapWaterCut.paths.fillet9 = fillet9;
                myHangClipGapWaterCut.paths.fillet10 = fillet10;
      } else if (area == "H") {
          var myHangClipGap = {
                paths: {
                  "TopArcH": new makerjs.paths.Arc([xh-w/2,yh], [xh,yh+h],[xh+w/2,yh]),
                  "LeftHolesH": new makerjs.paths.Circle([xh-w/2-od, yh+h1], r),
                  "RightHolesH":new makerjs.paths.Circle([xh+w/2+od,yh+h1], r),
                    }
              };
          
            //添加引爆槽和出入刀线
            var myHangClipGapWaterCut = {
                  paths: {
                        "EntryLineH":new makerjs.paths.Line([xh+w/2+cutLine,yh],[xh+w/2,yh]),  //入刀线       
                        "BigArcHup": new makerjs.paths.Arc([xh+w/2,yh],[oHX1up, oHY1up], o1r,false,false), 
                        "ExpSlotHLineEnUp":new makerjs.paths.Line([oHX1up, oHY1up], [oHX2up, oHY2up]), //引爆槽 线入
                        "UpHolesUpH":new makerjs.paths.Arc([oHX2up, oHY2up], [oHX3up, oHY3up], r,false,false),//上方孔
                        "UpHolesDnH":new makerjs.paths.Arc([oHX3up, oHY3up],[oHX2up, oHY2up],  r,false,false),//上方孔
                        "ExpSlotHLineExUp":new makerjs.paths.Line([oHX2up, oHY2up], [oHX1up, oHY1up]), //引爆槽 线出  
                        "BigArcHmid": new makerjs.paths.Arc([oHX1up, oHY1up],[oHX1dn, oHY1dn], o1r,false,false),
                        "ExpSlotHLineEnDn":new makerjs.paths.Line([oHX1dn, oHY1dn], [oHX2dn, oHY2dn]), //引爆槽 线入
                        "DownHolesUpH": new makerjs.paths.Arc([oHX2dn, oHY2dn], [oHX3dn, oHY3dn], r,false,false),//下方孔
                        "DownHolesDnH": new makerjs.paths.Arc([oHX3dn, oHY3dn],[oHX2dn, oHY2dn],  r,false,false),//下方孔
                        "ExpSlotHLineExDn":new makerjs.paths.Line([oHX2dn, oHY2dn], [oHX1dn, oHY1dn]), //引爆槽 线出   
                        "BigArcHdn": new makerjs.paths.Arc([oHX1dn, oHY1dn],[xh-w/2,yh], o1r,false,false),  
                        "ExitLineH": new makerjs.paths.Line([xh-w/2,yh],[xh-w/2-cutLine,yh]),//出刀线
                      }
                };               
                var fillet1 = makerjs.path.fillet(myHangClipGapWaterCut.paths.EntryLineH, myHangClipGapWaterCut.paths.BigArcHup, cutFilletRadius);
                var fillet2 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcHup, myHangClipGapWaterCut.paths.ExpSlotHLineEnUp, cutFilletRadius);
                var fillet3 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotHLineEnUp, myHangClipGapWaterCut.paths.UpHolesUpH, cutFilletRadius);
                var fillet4 = makerjs.path.fillet(myHangClipGapWaterCut.paths.UpHolesDnH, myHangClipGapWaterCut.paths.ExpSlotHLineExUp, cutFilletRadius);
                var fillet5 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotHLineExUp, myHangClipGapWaterCut.paths.BigArcHmid, cutFilletRadius);
                var fillet6 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcHmid, myHangClipGapWaterCut.paths.ExpSlotHLineEnDn, cutFilletRadius);
                var fillet7 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotHLineEnDn, myHangClipGapWaterCut.paths.DownHolesUpH, cutFilletRadius);
                var fillet8 = makerjs.path.fillet(myHangClipGapWaterCut.paths.DownHolesDnH, myHangClipGapWaterCut.paths.ExpSlotHLineExDn, cutFilletRadius);
                var fillet9 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotHLineExDn, myHangClipGapWaterCut.paths.BigArcHdn, cutFilletRadius);
                var fillet10 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcHdn, myHangClipGapWaterCut.paths.ExitLineH, cutFilletRadius);
                myHangClipGapWaterCut.paths.fillet1 = fillet1;
                myHangClipGapWaterCut.paths.fillet2 = fillet2;
                myHangClipGapWaterCut.paths.fillet3 = fillet3;
                myHangClipGapWaterCut.paths.fillet4 = fillet4;
                myHangClipGapWaterCut.paths.fillet5 = fillet5;
                myHangClipGapWaterCut.paths.fillet6 = fillet6;
                myHangClipGapWaterCut.paths.fillet7 = fillet7;
                myHangClipGapWaterCut.paths.fillet8 = fillet8;
                myHangClipGapWaterCut.paths.fillet9 = fillet9;
                myHangClipGapWaterCut.paths.fillet10 = fillet10;
      } else if (area == "I") {
       var myHangClipGap = {
          paths: {
            "TopArcI": new makerjs.paths.Arc([xi,yi], [xi-w/2,yi+h],[xi-w,yi]),
            "LeftHolesI": new makerjs.paths.Circle([xi+od, yi+h1], r),
            "RightHolesI":new makerjs.paths.Circle([xi-w-od,yi+h1], r),
          }
    };
    //添加引爆槽和出入刀线
    var myHangClipGapWaterCut = {
          paths: {
                "EntryLineI":new makerjs.paths.Line([xi+cutLine,yi],[xi,yi]),  //入刀线       
                "BigArcIup": new makerjs.paths.Arc([xi,yi],[oIX1up, oIY1up], o1r,false,false), 
                "ExpSlotILineEnUp":new makerjs.paths.Line([oIX1up, oIY1up], [oIX2up, oIY2up]), //引爆槽 线入
                "UpHolesUpI":new makerjs.paths.Arc([oIX2up, oIY2up], [oIX3up, oIY3up],r,false,false),//上方孔
                "UpHolesDnI":new makerjs.paths.Arc([oIX3up, oIY3up],[oIX2up, oIY2up], r,false,false),//上方孔
                "ExpSlotILineExUp":new makerjs.paths.Line([oIX2up, oIY2up], [oIX1up, oIY1up]), //引爆槽 线出  
                "BigArcImid": new makerjs.paths.Arc([oIX1up, oIY1up],[oIX1dn, oIY1dn], o1r,false,false),
                "ExpSlotILineEnDn":new makerjs.paths.Line([oIX1dn, oIY1dn], [oIX2dn, oIY2dn]), //引爆槽 线入
                "DownHolesUpI": new makerjs.paths.Arc([oIX2dn, oIY2dn], [oIX3dn, oIY3dn],r,false,false),//下方孔
                "DownHolesDnI": new makerjs.paths.Arc([oIX3dn, oIY3dn],[oIX2dn, oIY2dn], r,false,false),//下方孔
                "ExpSlotILineExDn":new makerjs.paths.Line([oIX2dn, oIY2dn], [oIX1dn, oIY1dn]), //引爆槽 线出   
                "BigArcIdn": new makerjs.paths.Arc([oIX1dn, oIY1dn],[xi-w,yi], o1r,false,false),  
                "ExitLineI": new makerjs.paths.Line([xi-w,yi],[xi-w-cutLine,yi]),//出刀线
              }
        };               
        var fillet1 = makerjs.path.fillet(myHangClipGapWaterCut.paths.EntryLineI, myHangClipGapWaterCut.paths.BigArcIup, cutFilletRadius);
        var fillet2 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcIup, myHangClipGapWaterCut.paths.ExpSlotILineEnUp, cutFilletRadius);
        var fillet3 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotILineEnUp, myHangClipGapWaterCut.paths.UpHolesUpI, cutFilletRadius);
        var fillet4 = makerjs.path.fillet(myHangClipGapWaterCut.paths.UpHolesDnI, myHangClipGapWaterCut.paths.ExpSlotILineExUp, cutFilletRadius);
        var fillet5 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotILineExUp, myHangClipGapWaterCut.paths.BigArcImid, cutFilletRadius);
        var fillet6 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcImid, myHangClipGapWaterCut.paths.ExpSlotILineEnDn, cutFilletRadius);
        var fillet7 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotILineEnDn, myHangClipGapWaterCut.paths.DownHolesUpI, cutFilletRadius);
        var fillet8 = makerjs.path.fillet(myHangClipGapWaterCut.paths.DownHolesDnI, myHangClipGapWaterCut.paths.ExpSlotILineExDn, cutFilletRadius);
        var fillet9 = makerjs.path.fillet(myHangClipGapWaterCut.paths.ExpSlotILineExDn, myHangClipGapWaterCut.paths.BigArcIdn, cutFilletRadius);
        var fillet10 = makerjs.path.fillet(myHangClipGapWaterCut.paths.BigArcIdn, myHangClipGapWaterCut.paths.ExitLineI, cutFilletRadius);
        myHangClipGapWaterCut.paths.fillet1 = fillet1;
        myHangClipGapWaterCut.paths.fillet2 = fillet2;
        myHangClipGapWaterCut.paths.fillet3 = fillet3;
        myHangClipGapWaterCut.paths.fillet4 = fillet4;
        myHangClipGapWaterCut.paths.fillet5 = fillet5;
        myHangClipGapWaterCut.paths.fillet6 = fillet6;
        myHangClipGapWaterCut.paths.fillet7 = fillet7;
        myHangClipGapWaterCut.paths.fillet8 = fillet8;
        myHangClipGapWaterCut.paths.fillet9 = fillet9;
        myHangClipGapWaterCut.paths.fillet10 = fillet10;
      }
}   
  return [myHangClipGap,myHangClipGapCut,myHangClipGapWaterCut];
};
// 矩形等去角标记 连线函数      
function creatmyHangClipGapMark(outParam, area, param, inputParam, fixedParam, OffsetParam, zoom) {
  console.log("是否调用此函数creatCornerMark()");
  console.log("是否调用此函数param", param);
  console.log("是否调用此函数outParam", outParam);
  console.log("是否调用此函数inputParam", inputParam);
  console.log("是否调用此函数OffsetParam", OffsetParam);
  var R=inputParam.R,W=inputParam.W,W1=inputParam.W1,H1=inputParam.H1,H=inputParam.H,D=inputParam.D,X=inputParam.X,Y=inputParam.Y, myZoom = zoom * 1,
  xa = param.xa, ya = param.ya, xb = param.xb, 
  yb = param.yb, xc = param.xc, 
  xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf, 
  yc = param.yc, xg = param.xg, yg = param.yg, 
  xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
  x = param.x0,y = param.y0, r = param.r, rd = param.rd,w = param.w,w1 = param.w1,h1 = param.h1, h = param.h,d = param.d,
//   x0,rd,r,w,w1,h,d 
        glassW = outParam.glassW, glassH = outParam.glassH,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
        markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
        w= W*1*myZoom,
        w1= W1*1*myZoom,
      h= H*1*myZoom,
      d= D*1*myZoom,
      h1= H1*1*myZoom,
      rd=r/Math.sqrt(2),
      hd=r-rd,
      od=(w1-w)/2,
        x0 = X*1*myZoom,
        y0 = Y*1*myZoom;
        if(d!==0){
         var TxtD="∮"+d;
        }
        if(h!==0){
         var TxtH=H;
        }
        if(w!==0){
         var TxtW=W;
        }
        if(w1!==0){
         var TxtW1=W1;
        }
        if(h1!==0){
         var TxtH1=H1;
        }
        if(x0!==0){          
        var TxtX=X;
        }
        if(y0!==0){          
         var TxtY=Y;
        }
if(glassW*1<glassH * 1){
            console.log("长边在X轴￥￥￥￥￥");
 if (area == "A") {
                 var myHangClipAMakerW = {
                   paths: {
                     "WALine0": new makerjs.paths.Line([xa-3*markShift,ya], [xa, ya]),
                      "WALine1": new makerjs.paths.Line([xa-3*markShift,ya-w], [xa, ya-w]),
                       "WALine": new makerjs.paths.Line([xa-markShift,ya-w], [xa-markShift, ya]),
                          }
                   };
                  var myHangClipAMakerW1 = {
                  paths: {
                        "W1ALine0": new makerjs.paths.Line([xa+h1,ya+od], [xa+h1+markShiftFour,ya+od]),
                        "W1ALine1": new makerjs.paths.Line([xa+h1,ya-w-od], [xa+h1+markShiftFour,ya-w-od]),
                       "W1ALine": new makerjs.paths.Line([xa+h1+markShift,ya+od], [xa+h1+markShift,ya-w-od]),
                        }
                  };
                  var myHangClipAMakerD = {
                        paths: {
                               "DALine0": new makerjs.paths.Line([xa+h1,ya-w-od], [xa+h1+rd+markHolesOneD,ya-w-od-rd-markHolesOneD]),
                              }
                  };
                  var myHangClipAMakerX = {
                        paths: {
                              "XALine0": new makerjs.paths.Line([xa-markShiftFour,ya], [xa, ya]),
                              "XALine1": new makerjs.paths.Line([xa-markShiftFour,ya+y0], [xa-x0, ya+y0]),
                              "XALine2": new makerjs.paths.Line([xa-markShiftTwo,ya], [xa-markShiftTwo, ya+y0]),
                        }
                  };
                  var myHangClipAMakerH = {
                        paths: {
                           "HALine0": new makerjs.paths.Line([xa+h,ya+markShiftFour], [xa+h, ya-w/2]),
                           "HALine1": new makerjs.paths.Line([xa+h,ya+markShift], [xa, ya+markShift]),
                        }
                  };
                  var myHangClipAMakerH1 = {
                        paths: {
                           "H1ALine0": new makerjs.paths.Line([xa+h1,ya-w], [xa+h1, ya-w-markShiftFour-markShift]),
                           "H1ALine1":new makerjs.paths.Line([xa+h1,ya-w-markShiftFour], [xa, ya-w-markShiftFour]),
                        }
                  };
                  makerjs.model.addCaption(myHangClipAMakerW, TxtW, [xa-markShiftThree,ya-w], [xa-markShiftThree, ya]);//W文字标注
                  makerjs.model.addCaption(myHangClipAMakerW1, TxtW1, [xa+h1+2*markShift,ya-w-od], [xa+h1+2*markShift,ya+od]);//W1文字标注
                    makerjs.model.addCaption(myHangClipAMakerX, TxtY, [xa-markShiftFour,ya], [xa-markShiftFour, ya+y0]);//X文字标注
                    makerjs.model.addCaption(myHangClipAMakerH, TxtH, [xa,ya+markShiftFour], [xa+h, ya+markShiftFour]);//H文字标注    
                    makerjs.model.addCaption(myHangClipAMakerH1, TxtH1,[xa,ya-w-markShiftFour-markShift], [xa+h1, ya-w-markShiftFour-markShift]);//H1文字标注    
                    makerjs.model.addCaption(myHangClipAMakerD, TxtD, [xa+h1+rd+markHolesOneD,ya-w-od-rd-markHolesOneD],[xa+h1+rd+d+2*markHolesOneD, ya-w-od-rd-d-2*markHolesOneD]);//D文字标注  
                    var markers = [myHangClipAMakerX,myHangClipAMakerW,myHangClipAMakerW1,myHangClipAMakerH,myHangClipAMakerH1,myHangClipAMakerD]
} else if (area == "C") {
  var myHangClipCMakerW = {
    paths: {
      "WALine0": new makerjs.paths.Line([xc+3*markShift,yc], [xc, yc]),
       "WALine1": new makerjs.paths.Line([xc+3*markShift,yc-w], [xc, yc-w]),
        "WALine": new makerjs.paths.Line([xc+markShift,yc-w], [xc+markShift, yc]),
           }
    };
   var myHangClipCMakerW1 = {
   paths: {
         "W1ALine0": new makerjs.paths.Line([xc-h1,yc+od], [xc-h1-markShiftFour,yc+od]),
         "W1ALine1": new makerjs.paths.Line([xc-h1,yc-w-od], [xc-h1-markShiftFour,yc-w-od]),
        "W1ALine": new makerjs.paths.Line([xc-h1-markShift,yc+od], [xc-h1-markShift,yc-w-od]),
         }
   };
   var myHangClipCMakerD = {
         paths: {
                "DALine0": new makerjs.paths.Line([xc-h1,yc-w-od], [xc-h1-rd-markHolesOneD,yc-w-od-rd-markHolesOneD]),
               }
   };
   var myHangClipCMakerX = {
         paths: {
               "XALine0": new makerjs.paths.Line([xc+markShiftFour,yc], [xc, yc]),
               "XALine1": new makerjs.paths.Line([xc+markShiftFour,yc+y0], [xc+x0, yc+y0]),
               "XALine2": new makerjs.paths.Line([xc+markShiftTwo,yc], [xc+markShiftTwo, yc+y0]),
         }
   };
   var myHangClipCMakerH = {
         paths: {
            "HALine0": new makerjs.paths.Line([xc-h,yc+markShiftFour], [xc-h, yc-w/2]),
            "HALine1": new makerjs.paths.Line([xc-h,yc+markShift], [xc, yc+markShift]),
         }
   };
   var myHangClipCMakerH1 = {
         paths: {
            "H1ALine0": new makerjs.paths.Line([xc-h1,yc-w], [xc-h1, yc-w-markShiftFour-markShift]),
            "H1ALine1":new makerjs.paths.Line([xc-h1,yc-w-markShiftFour], [xc, yc-w-markShiftFour]),
         }
   };
   makerjs.model.addCaption(myHangClipCMakerW, TxtW, [xc+markShiftThree,yc-w], [xc+markShiftThree, yc]);//W文字标注
   makerjs.model.addCaption(myHangClipCMakerW1, TxtW1, [xc-h1-2*markShift,yc-w-od], [xc-h1-2*markShift,yc+od]);//W1文字标注
     makerjs.model.addCaption(myHangClipCMakerX, TxtY, [xc+markShiftFour,yc], [xc+markShiftFour, yc+y0]);//X文字标注
     makerjs.model.addCaption(myHangClipCMakerH, TxtH, [xc,yc+markShiftFour], [xc-h, yc+markShiftFour]);//H文字标注    
     makerjs.model.addCaption(myHangClipCMakerH1, TxtH1,[xc,yc-w-markShiftFour-markShift], [xc-h1, yc-w-markShiftFour-markShift]);//H1文字标注    
     makerjs.model.addCaption(myHangClipCMakerD, TxtD, [xc-h1-rd-markHolesOneD,yc-w-od-rd-markHolesOneD],[xc-h1-rd-d-2*markHolesOneD, yc-w-od-rd-d-2*markHolesOneD]);//D文字标注  
     var markers = [myHangClipCMakerX,myHangClipCMakerW,myHangClipCMakerW1,myHangClipCMakerH,myHangClipCMakerH1,myHangClipCMakerD]
} else if (area == "D") {
  var myHangClipDMakerW = {
    paths: {
      "WDLine0": new makerjs.paths.Line([xd-3*markShift,yd+w/2], [xd, yd+w/2]),
       "WDLine1": new makerjs.paths.Line([xd-3*markShift,yd-w/2], [xd, yd-w/2]),
        "WDLine": new makerjs.paths.Line([xd-markShift,yd-w/2], [xd-markShift, yd+w/2]),
           }
    };
   var myHangClipDMakerW1 = {
   paths: {
         "W1DLine0": new makerjs.paths.Line([xd+h1,yd+od+w/2], [xd+h1+markShiftFour,yd+od+w/2]),
         "W1DLine1": new makerjs.paths.Line([xd+h1,yd-w/2-od], [xd+h1+markShiftFour,yd-w/2-od]),
        "W1DLine": new makerjs.paths.Line([xd+h1+markShift,yd+od+w/2], [xd+h1+markShift,yd-w/2-od]),
         }
   };
   var myHangClipDMakerD = {
         paths: {
                "DDLine0": new makerjs.paths.Line([xd+h1,yd-w-od+w/2], [xd+h1+rd+markHolesOneD,yd-w-od-rd+w/2-markHolesOneD]),
               }
   };
   var myHangClipDMakerX = {
         paths: {
               "XDLine0": new makerjs.paths.Line([xd-markShiftFour,yd+w/2], [xd, yd+w/2]),
               "XDLine1": new makerjs.paths.Line([xd-markShiftFour,yd+y0+w/2], [xd-x0, yd+y0+w/2]),
               "XDLine2": new makerjs.paths.Line([xd-markShiftTwo,yd+w/2], [xd-markShiftTwo, yd+y0+w/2]),
         }
   };
   var myHangClipDMakerH = {
         paths: {
            "HDLine0": new makerjs.paths.Line([xd+h,yd+markShiftFour+w/2], [xd+h, yd-w/2+w/2]),
            "HDLine1": new makerjs.paths.Line([xd+h,yd+markShift+w/2], [xd, yd+markShift+w/2]),
         }
   };
   var myHangClipDMakerH1 = {
         paths: {
            "H1DLine0": new makerjs.paths.Line([xd+h1,yd-w/2], [xd+h1, yd-w/2-markShiftFour-markShift]),
            "H1DLine1":new makerjs.paths.Line([xd+h1,yd-w/2-markShiftFour], [xd, yd-w/2-markShiftFour]),
         }
   };
   makerjs.model.addCaption(myHangClipDMakerW, TxtW, [xd-markShiftFour,yd-w/2], [xd-markShiftFour, yd+w/2]);//W文字标注
   makerjs.model.addCaption(myHangClipDMakerW1, TxtW1, [xd+h1+2*markShift,yd-w/2-od], [xd+h1+2*markShift,yd+od+w/2]);//W1文字标注
     makerjs.model.addCaption(myHangClipDMakerX, TxtY, [xd-markShiftFour,yd+w/2], [xd-markShiftFour, yd+y0+w/2]);//X文字标注
     makerjs.model.addCaption(myHangClipDMakerH, TxtH, [xd,yd+markShiftFour+w/2], [xd+h, yd+markShiftFour+w/2]);//H文字标注    
     makerjs.model.addCaption(myHangClipDMakerH1, TxtH1,[xd,yd-w/2-markShiftFour-markShift], [xd+h1, yd-w/2-markShiftFour-markShift]);//H1文字标注    
     makerjs.model.addCaption(myHangClipDMakerD, TxtD, [xd+h1+rd+markHolesOneD,yd-w/2-od-rd-markHolesOneD],[xd+h1+rd+d+2*markHolesOneD, yd-w/2-od-rd-d-2*markHolesOneD]);//D文字标注  
     var markers = [myHangClipDMakerX,myHangClipDMakerW,myHangClipDMakerW1,myHangClipDMakerH,myHangClipDMakerH1,myHangClipDMakerD]
} else if (area == "F") {
  var myHangClipFMakerW = {
    paths: {
      "WFLine0": new makerjs.paths.Line([xf+3*markShift,yf+w/2], [xf, yf+w/2]),
       "WFLine1": new makerjs.paths.Line([xf+3*markShift,yf-w/2], [xf, yf-w/2]),
        "WFLine": new makerjs.paths.Line([xf+markShift,yf-w/2], [xf+markShift, yf+w/2]),
           }
    };
   var myHangClipFMakerW1 = {
   paths: {
         "W1FLine0": new makerjs.paths.Line([xf-h1,yf+od+w/2], [xf-h1-markShiftFour,yf+od+w/2]),
         "W1FLine1": new makerjs.paths.Line([xf-h1,yf-w/2-od], [xf-h1-markShiftFour,yf-w/2-od]),
        "W1FLine": new makerjs.paths.Line([xf-h1-markShift,yf+od+w/2], [xf-h1-markShift,yf-w/2-od]),
         }
   };
   var myHangClipFMakerD = {
         paths: {
                "DFLine0": new makerjs.paths.Line([xf-h1,yf-w-od+w/2], [xf-h1-rd-markHolesOneD,yf-w-od-rd+w/2-markHolesOneD]),
               }
   };
   var myHangClipFMakerX = {
         paths: {
               "XFLine0": new makerjs.paths.Line([xf+markShiftFour,yf+w/2], [xf, yf+w/2]),
               "XFLine1": new makerjs.paths.Line([xf+markShiftFour,yf+y0+w/2], [xf+x0, yf+y0+w/2]),
               "XFLine2": new makerjs.paths.Line([xf+markShiftTwo,yf+w/2], [xf+markShiftTwo, yf+y0+w/2]),
         }
   };
   var myHangClipFMakerH = {
         paths: {
            "HFLine0": new makerjs.paths.Line([xf-h,yf+markShiftFour+w/2], [xf-h, yf-w/2+w/2]),
            "HFLine1": new makerjs.paths.Line([xf-h,yf+markShift+w/2], [xf, yf+markShift+w/2]),
         }
   };
   var myHangClipFMakerH1 = {
         paths: {
            "H1FLine0": new makerjs.paths.Line([xf-h1,yf-w/2], [xf-h1, yf-w/2-markShiftFour-markShift]),
            "H1FLine1":new makerjs.paths.Line([xf-h1,yf-w/2-markShiftFour], [xf, yf-w/2-markShiftFour]),
         }
   };
   makerjs.model.addCaption(myHangClipFMakerW, TxtW, [xf+markShiftFour,yf-w/2], [xf+markShiftFour, yf+w/2]);//W文字标注
   makerjs.model.addCaption(myHangClipFMakerW1, TxtW1, [xf-h1-2*markShift,yf-w/2-od], [xf-h1-2*markShift,yf+od+w/2]);//W1文字标注
     makerjs.model.addCaption(myHangClipFMakerX, TxtY, [xf+markShiftFour,yf+w/2], [xf+markShiftFour, yf+y0+w/2]);//X文字标注
     makerjs.model.addCaption(myHangClipFMakerH, TxtH, [xf,yf+markShiftFour+w/2], [xf-h, yf+markShiftFour+w/2]);//H文字标注    
     makerjs.model.addCaption(myHangClipFMakerH1, TxtH1,[xf,yf-w/2-markShiftFour-markShift], [xf-h1, yf-w/2-markShiftFour-markShift]);//H1文字标注    
     makerjs.model.addCaption(myHangClipFMakerD, TxtD, [xf-h1-rd-markHolesOneD,yf-w/2-od-rd-markHolesOneD],[xf-h1-rd-d-2*markHolesOneD, yf-w/2-od-rd-d-2*markHolesOneD]);//D文字标注  
     var markers = [myHangClipFMakerX,myHangClipFMakerW,myHangClipFMakerW1,myHangClipFMakerH,myHangClipFMakerH1,myHangClipFMakerD]
} else if (area == "G") {
  var myHangClipGMakerW = {
    paths: {
      "WGLine0": new makerjs.paths.Line([xg-3*markShift,yg], [xg, yg]),
       "WGLine1": new makerjs.paths.Line([xg-3*markShift,yg+w], [xg, yg+w]),
        "WGLine": new makerjs.paths.Line([xg-markShift,yg+w], [xg-markShift, yg]),
           }
    };
   var myHangClipGMakerW1 = {
   paths: {
         "W1GLine0": new makerjs.paths.Line([xg+h1,yg-od], [xg+h1+markShiftFour,yg-od]),
         "W1GLine1": new makerjs.paths.Line([xg+h1,yg+w+od], [xg+h1+markShiftFour,yg+w+od]),
        "W1GLine": new makerjs.paths.Line([xg+h1+markShift,yg-od], [xg+h1+markShift,yg+w+od]),
         }
   };
   var myHangClipGMakerD = {
         paths: {
                "DGLine0": new makerjs.paths.Line([xg+h1,yg+w+od], [xg+h1+rd+markHolesOneD,yg+w+od+rd+markHolesOneD]),
               }
   };
   var myHangClipGMakerX = {
         paths: {
               "XGLine0": new makerjs.paths.Line([xg-markShiftFour,yg], [xg, yg]),
               "XGLine1": new makerjs.paths.Line([xg-markShiftFour,yg-y0], [xg-x0, yg-y0]),
               "XGLine2": new makerjs.paths.Line([xg-markShiftTwo,yg], [xg-markShiftTwo, yg-y0]),
         }
   };
   var myHangClipGMakerH = {
         paths: {
            "HGLine0": new makerjs.paths.Line([xg+h,yg-markShiftFour], [xg+h, yg+w/2]),
            "HGLine1": new makerjs.paths.Line([xg+h,yg-markShift], [xg, yg-markShift]),
         }
   };
   var myHangClipGMakerH1 = {
         paths: {
            "H1GLine0": new makerjs.paths.Line([xg+h1,yg+w], [xg+h1, yg+w+markShiftFour+markShift]),
            "H1GLine1":new makerjs.paths.Line([xg+h1,yg+w+markShiftFour], [xg, yg+w+markShiftFour]),
         }
   };
   makerjs.model.addCaption(myHangClipGMakerW, TxtW, [xg-markShiftThree,yg+w], [xg-markShiftThree, yg]);//W文字标注
   makerjs.model.addCaption(myHangClipGMakerW1, TxtW1, [xg+h1+2*markShift,yg+w+od], [xg+h1+2*markShift,yg-od]);//W1文字标注
     makerjs.model.addCaption(myHangClipGMakerX, TxtY, [xg-markShiftFour,yg], [xg-markShiftFour, yg-y0]);//X文字标注
     makerjs.model.addCaption(myHangClipGMakerH, TxtH, [xg,yg-markShiftFour], [xg+h, yg-markShiftFour]);//H文字标注    
     makerjs.model.addCaption(myHangClipGMakerH1, TxtH1,[xg,yg+w+markShiftFour+markShift], [xg+h1, yg+w+markShiftFour+markShift]);//H1文字标注    
     makerjs.model.addCaption(myHangClipGMakerD, TxtD, [xg+h1+rd+markHolesOneD,yg+w+od+rd+markHolesOneD],[xg+h1+rd+d+2*markHolesOneD, yg+w+od+rd+d+2*markHolesOneD]);//D文字标注  
     var markers = [myHangClipGMakerX,myHangClipGMakerW,myHangClipGMakerW1,myHangClipGMakerH,myHangClipGMakerH1,myHangClipGMakerD]
} else if (area == "I") {
  var myHangClipIMakerW = {
    paths: {
      "WILine0": new makerjs.paths.Line([xi+3*markShift,yi], [xi, yi]),
       "WILine1": new makerjs.paths.Line([xi+3*markShift,yi+w], [xi, yi+w]),
        "WILine": new makerjs.paths.Line([xi+markShift,yi+w], [xi+markShift, yi]),
           }
    };
   var myHangClipIMakerW1 = {
   paths: {
         "W1ILine0": new makerjs.paths.Line([xi-h1,yi-od], [xi-h1-markShiftFour,yi-od]),
         "W1ILine1": new makerjs.paths.Line([xi-h1,yi+w+od], [xi-h1-markShiftFour,yi+w+od]),
        "W1ILine": new makerjs.paths.Line([xi-h1-markShift,yi-od], [xi-h1-markShift,yi+w+od]),
         }
   };
   var myHangClipIMakerD = {
         paths: {
                "DILine0": new makerjs.paths.Line([xi-h1,yi+w+od], [xi-h1-rd-markHolesOneD,yi+w+od+rd+markHolesOneD]),
               }
   };
   var myHangClipIMakerX = {
         paths: {
               "XILine0": new makerjs.paths.Line([xi+markShiftFour,yi], [xi, yi]),
               "XILine1": new makerjs.paths.Line([xi+markShiftFour,yi-y0], [xi+x0, yi-y0]),
               "XILine2": new makerjs.paths.Line([xi+markShiftTwo,yi], [xi+markShiftTwo, yi-y0]),
         }
   };
   var myHangClipIMakerH = {
         paths: {
            "HILine0": new makerjs.paths.Line([xi-h,yi-markShiftFour], [xi-h, yi+w/2]),
            "HILine1": new makerjs.paths.Line([xi-h,yi-markShift], [xi, yi-markShift]),
         }
   };
   var myHangClipIMakerH1 = {
         paths: {
            "H1ILine0": new makerjs.paths.Line([xi-h1,yi+w], [xi-h1, yi+w+markShiftFour+markShift]),
            "H1ILine1":new makerjs.paths.Line([xi-h1,yi+w+markShiftFour], [xi, yi+w+markShiftFour]),
         }
   };
   makerjs.model.addCaption(myHangClipIMakerW, TxtW, [xi+markShiftThree,yi+w], [xi+markShiftThree, yi]);//W文字标注
   makerjs.model.addCaption(myHangClipIMakerW1, TxtW1, [xi-h1-2*markShift,yi+w+od], [xi-h1-2*markShift,yi-od]);//W1文字标注
     makerjs.model.addCaption(myHangClipIMakerX, TxtY, [xi+markShiftFour,yi], [xi+markShiftFour, yi-y0]);//X文字标注
     makerjs.model.addCaption(myHangClipIMakerH, TxtH, [xi-h,yi+markShiftFour], [xi, yi+markShiftFour]);//H文字标注    
     makerjs.model.addCaption(myHangClipIMakerH1, TxtH1,[xi,yi+w+markShiftFour+markShift], [xi-h1, yi+w+markShiftFour+markShift]);//H1文字标注    
     makerjs.model.addCaption(myHangClipIMakerD, TxtD, [xi-h1-rd-markHolesOneD,yi+w+od+rd+markHolesOneD],[xi-h1-rd-d-2*markHolesOneD, yi+w+od+rd+d+2*markHolesOneD]);//D文字标注  
     var markers = [myHangClipIMakerX,myHangClipIMakerW,myHangClipIMakerW1,myHangClipIMakerH,myHangClipIMakerH1,myHangClipIMakerD]
}     
 }else{
            console.log("短边在X轴￥￥￥￥￥");
            if (area == "A") {
              var myHangClipAMakerW = {
                paths: {
                  "WALine0": new makerjs.paths.Line([xa,ya], [xa, ya+3*markShift]),
                   "WALine1": new makerjs.paths.Line([xa+w,ya], [xa+w, ya+3*markShift]),
                    "WALine": new makerjs.paths.Line([xa,ya+markShift], [xa+w, ya+markShift]),
                       }
                };
               var myHangClipAMakerW1 = {
               paths: {
                     "W1ALine0": new makerjs.paths.Line([xa-od,ya-h1], [xa-od,ya-h1-markShiftFour]),
                     "W1ALine1": new makerjs.paths.Line([xa+w+od,ya-h1], [xa+w+od,ya-h1-markShiftFour]),
                    "W1ALine": new makerjs.paths.Line([xa-od,ya-h1-markShift], [xa+w+od,ya-h1-markShift]),
                     }
               };
               var myHangClipAMakerD = {
                     paths: {
                            "DALine0": new makerjs.paths.Line([xa+w+od,ya-h1], [xa+w+od+rd+markHolesOneD,ya-h1-rd-markHolesOneD]),
                           }
               };
               var myHangClipAMakerX = {
                     paths: {
                           "XALine0": new makerjs.paths.Line([xa,ya], [xa, ya+markShiftFour]),
                           "XALine1": new makerjs.paths.Line([xa-x0,ya], [xa-x0, ya+markShiftFour]),
                           "XALine2": new makerjs.paths.Line([xa-x0,ya+markShiftTwo], [xa, ya+markShiftTwo]),
                     }
               };
               var myHangClipAMakerH = {
                     paths: {
                        "HALine0": new makerjs.paths.Line([xa-markShiftFour,ya-h], [xa+w/2, ya-h]),
                        "HALine1": new makerjs.paths.Line([xa-markShift,ya-h], [xa-markShift, ya]),
                     }
               };
               var myHangClipAMakerH1 = {
                     paths: {
                        "H1ALine0": new makerjs.paths.Line([xa+w,ya-h1], [xa+w+markShiftFour+markShift, ya-h1]),
                        "H1ALine1":new makerjs.paths.Line([xa+w+markShiftFour,ya-h1], [xa+w+markShiftFour, ya]),
                     }
               };
               makerjs.model.addCaption(myHangClipAMakerW, TxtW, [xa,ya+2*markShiftThree], [xa+w, ya+2*markShiftThree]);//W文字标注
               makerjs.model.addCaption(myHangClipAMakerW1, TxtW1, [xa-od,ya-h1-2*markShift], [xa+w+od,ya-h1-2*markShift]);//W1文字标注
                 makerjs.model.addCaption(myHangClipAMakerX, TxtX, [xa-x0,ya+markShiftFour], [xa, ya+markShiftFour]);//X文字标注
                 makerjs.model.addCaption(myHangClipAMakerH, TxtH, [xa-markShiftFour,ya-h], [xa-markShiftFour, ya]);//H文字标注    
                 makerjs.model.addCaption(myHangClipAMakerH1, TxtH1,[xa+w+markShiftFour+markShift,ya-h1], [xa+w+markShiftFour+markShift, ya]);//H1文字标注    
                 makerjs.model.addCaption(myHangClipAMakerD, TxtD, [xa+w+od+rd+markHolesOneD,ya-h1-rd-markHolesOneD],[xa+w+od+rd+d+2*markHolesOneD, ya-h1-rd-d-2*markHolesOneD]);//D文字标注  
                 var markers = [myHangClipAMakerX,myHangClipAMakerW,myHangClipAMakerW1,myHangClipAMakerH,myHangClipAMakerH1,myHangClipAMakerD]
} else if (area == "B") {
var myHangClipBMakerW = {
 paths: {
   "WBLine0": new makerjs.paths.Line([xb-w/2,yb], [xb-w/2, yb+3*markShift]),
    "WBLine1": new makerjs.paths.Line([xb+w/2,yb], [xb+w/2, yb+3*markShift]),
     "WBLine": new makerjs.paths.Line([xb-w/2,yb+markShift], [xb+w/2, yb+markShift]),
        }
 };
var myHangClipBMakerW1 = {
paths: {
      "W1BLine0": new makerjs.paths.Line([xb-w/2-od,yb-h1], [xb-w/2-od,yb-h1-markShiftFour]),
      "W1BLine1": new makerjs.paths.Line([xb+w/2+od,yb-h1], [xb+w/2+od,yb-h1-markShiftFour]),
     "W1BLine": new makerjs.paths.Line([xb-w/2-od,yb-h1-markShift], [xb+w/2+od,yb-h1-markShift]),
      }
};
var myHangClipBMakerD = {
      paths: {
             "DBLine0": new makerjs.paths.Line([xb+w/2+od,yb-h1], [xb+w/2+od+rd+markHolesOneD,yb-h1-rd-markHolesOneD]),
            }
};
var myHangClipBMakerX = {
      paths: {
            "XBLine0": new makerjs.paths.Line([xb-w/2,yb], [xb-w/2, yb+markShiftFour]),
            "XBLine1": new makerjs.paths.Line([xb-w/2-x0,yb], [xb-w/2-x0, yb+markShiftFour]),
            "XBLine2": new makerjs.paths.Line([xb-w/2-x0,yb+markShiftTwo], [xb-w/2, yb+markShiftTwo]),
      }
};
var myHangClipBMakerH = {
      paths: {
         "HBLine0": new makerjs.paths.Line([xb-w/2-markShiftFour,yb-h], [xb, yb-h]),
         "HBLine1": new makerjs.paths.Line([xb-w/2-markShift,yb-h], [xb-w/2-markShift, yb]),
      }
};
var myHangClipBMakerH1 = {
      paths: {
         "H1BLine0": new makerjs.paths.Line([xb+w/2,yb-h1], [xb+w/2+markShiftFour+markShift, yb-h1]),
         "H1BLine1":new makerjs.paths.Line([xb+w/2+markShiftFour,yb-h1], [xb+w/2+markShiftFour, yb]),
      }
};
makerjs.model.addCaption(myHangClipBMakerW, TxtW, [xb-w/2,yb+2*markShiftThree], [xb+w/2, yb+2*markShiftThree]);//W文字标注
makerjs.model.addCaption(myHangClipBMakerW1, TxtW1, [xb-w/2-od,yb-h1-2*markShift], [xb+w/2+od,yb-h1-2*markShift]);//W1文字标注
  makerjs.model.addCaption(myHangClipBMakerX, TxtX, [xb-w/2-x0,yb+markShiftFour], [xb-w/2, yb+markShiftFour]);//X文字标注
  makerjs.model.addCaption(myHangClipBMakerH, TxtH, [xb-w/2-markShiftFour,yb-h], [xb-w/2-markShiftFour, yb]);//H文字标注    
  makerjs.model.addCaption(myHangClipBMakerH1, TxtH1,[xb+w/2+markShiftFour+markShift,yb-h1], [xb+w/2+markShiftFour+markShift, yb+0]);//H1文字标注    
  makerjs.model.addCaption(myHangClipBMakerD, TxtD, [xb+w/2+od+rd+markHolesOneD,yb-h1-rd-markHolesOneD],[xb+w/2+od+rd+d+2*markHolesOneD, yb-h1-rd-d-2*markHolesOneD]);//D文字标注  
  var markers = [myHangClipBMakerX,myHangClipBMakerW,myHangClipBMakerW1,myHangClipBMakerH,myHangClipBMakerH1,myHangClipBMakerD]
} else if (area == "C") {
var myHangClipCMakerW = {
 paths: {
   "WALine0": new makerjs.paths.Line([xc,yc], [xc, yc+3*markShift]),
    "WALine1": new makerjs.paths.Line([xc-w,yc], [xc-w, yc+3*markShift]),
     "WALine": new makerjs.paths.Line([xc,yc+markShift], [xc-w, yc+markShift]),
        }
 };
var myHangClipCMakerW1 = {
paths: {
      "W1ALine0": new makerjs.paths.Line([xc+od,yc-h1], [xc+od,yc-h1-markShiftFour]),
      "W1ALine1": new makerjs.paths.Line([xc-w-od,yc-h1], [xc-w-od,yc-h1-markShiftFour]),
     "W1ALine": new makerjs.paths.Line([xc+od,yc-h1-markShift], [xc-w-od,yc-h1-markShift]),
      }
};
var myHangClipCMakerD = {
      paths: {
             "RALine0": new makerjs.paths.Line([xc-w-od,yc-h1], [xc-w-od-rd-markHolesOneD,yc-h1-rd-markHolesOneD]),
            }
};
var myHangClipCMakerX = {
      paths: {
            "XALine0": new makerjs.paths.Line([xc,yc], [xc, yc+markShiftFour]),
            "XALine1": new makerjs.paths.Line([xc+x0,yc], [xc+x0, yc+markShiftFour]),
            "XALine2": new makerjs.paths.Line([xc+x0,yc+markShiftTwo], [xc, yc+markShiftTwo]),
      }
};
var myHangClipCMakerH = {
      paths: {
         "HALine0": new makerjs.paths.Line([xc+markShiftFour,yc-h], [xc-w/2, yc-h]),
         "HALine1": new makerjs.paths.Line([xc+markShift,yc-h], [xc+markShift, yc]),
      }
};
var myHangClipCMakerH1 = {
      paths: {
         "H1ALine0": new makerjs.paths.Line([xc-w,yc-h1], [xc-w-markShiftFour-markShift, yc-h1]),
         "H1ALine1":new makerjs.paths.Line([xc-w-markShiftFour,yc-h1], [xc-w-markShiftFour, yc]),
      }
};
makerjs.model.addCaption(myHangClipCMakerW, TxtW, [xc-w,yc+2*markShiftThree], [xc, yc+2*markShiftThree]);//W文字标注
makerjs.model.addCaption(myHangClipCMakerW1, TxtW1, [xc-w-od,yc-h1-2*markShift], [xc+od,yc-h1-2*markShift]);//W1文字标注
  makerjs.model.addCaption(myHangClipCMakerX, TxtX, [xc, yc+markShiftFour], [xc+x0,yc+markShiftFour]);//X文字标注
  makerjs.model.addCaption(myHangClipCMakerH, TxtH, [xc+markShiftFour,yc-h], [xc+markShiftFour, yc]);//H文字标注    
  makerjs.model.addCaption(myHangClipCMakerH1, TxtH1,[xc-w-markShiftFour-markShift,yc-h1], [xc-w-markShiftFour-markShift, yc]);//H1文字标注    
  makerjs.model.addCaption(myHangClipCMakerD, TxtD, [xc-w-od-rd-markHolesOneD,yc-h1-rd-markHolesOneD],[xc-w-od-rd-d-2*markHolesOneD, yc-h1-rd-d-2*markHolesOneD]);//D文字标注  
  var markers = [myHangClipCMakerX,myHangClipCMakerW,myHangClipCMakerW1,myHangClipCMakerH,myHangClipCMakerH1,myHangClipCMakerD]
} else if (area == "G") {
var myHangClipGMakerW = {
 paths: {
   "WGLine0": new makerjs.paths.Line([xg,yg], [xg, yg-3*markShift]),
    "WGLine1": new makerjs.paths.Line([xg+w,yg], [xg+w, yg-3*markShift]),
     "WGLine": new makerjs.paths.Line([xg,yg-markShift], [xg+w, yg-markShift]),
        }
 };
var myHangClipGMakerW1 = {
paths: {
      "W1GLine0": new makerjs.paths.Line([xg-od,yg+h1], [xg-od,yg+h1+markShiftFour]),
      "W1GLine1": new makerjs.paths.Line([xg+w+od,yg+h1], [xg+w+od,yg+h1+markShiftFour]),
     "W1GLine": new makerjs.paths.Line([xg-od,yg+h1+markShift], [xg+w+od,yg+h1+markShift]),
      }
};
var myHangClipGMakerD = {
      paths: {
             "DGLine0": new makerjs.paths.Line([xg+w+od,yg+h1], [xg+w+od+rd+markHolesOneD,yg+h1+rd+markHolesOneD]),
            }
};
var myHangClipGMakerX = {
      paths: {
            "XGLine0": new makerjs.paths.Line([xg,yg], [xg, yg-markShiftFour]),
            "XGLine1": new makerjs.paths.Line([xg-x0,yg], [xg-x0, yg-markShiftFour]),
            "XGLine2": new makerjs.paths.Line([xg-x0,yg-markShiftTwo], [xg, yg-markShiftTwo]),
      }
};
var myHangClipGMakerH = {
      paths: {
         "HGLine0": new makerjs.paths.Line([xg-markShiftFour,yg+h], [xg+w/2, yg+h]),
         "HGLine1": new makerjs.paths.Line([xg-markShift,yg+h], [xg-markShift, yg]),
      }
};
var myHangClipGMakerH1 = {
      paths: {
         "H1GLine0": new makerjs.paths.Line([xg+w,yg+h1], [xg+w+markShiftFour+markShift, yg+h1]),
         "H1GLine1":new makerjs.paths.Line([xg+w+markShiftFour,yg+h1], [xg+w+markShiftFour, yg]),
      }
};
makerjs.model.addCaption(myHangClipGMakerW, TxtW, [xg,yg-2*markShiftThree], [xg+w, yg-2*markShiftThree]);//W文字标注
makerjs.model.addCaption(myHangClipGMakerW1, TxtW1, [xg-od,yg+h1+2*markShift], [xg+w+od,yg+h1+2*markShift]);//W1文字标注
  makerjs.model.addCaption(myHangClipGMakerX, TxtX, [xg-x0,yg-markShiftFour], [xg, yg-markShiftFour]);//X文字标注
  makerjs.model.addCaption(myHangClipGMakerH, TxtH, [xg-markShiftFour,yg+h], [xg-markShiftFour, yg]);//H文字标注    
  makerjs.model.addCaption(myHangClipGMakerH1, TxtH1,[xg+w+markShiftFour+markShift,yg+h1], [xg+w+markShiftFour+markShift, yg]);//H1文字标注    
  makerjs.model.addCaption(myHangClipGMakerD, TxtD, [xg+w+od+rd+markHolesOneD,yg+h1+rd+markHolesOneD],[xg+w+od+rd+d+2*markHolesOneD, yg+h1+rd+d+2*markHolesOneD]);//D文字标注  
  var markers = [myHangClipGMakerX,myHangClipGMakerW,myHangClipGMakerW1,myHangClipGMakerH,myHangClipGMakerH1,myHangClipGMakerD]
} else if (area == "H") {
var myHangClipHMakerW = {
 paths: {
   "WHLine0": new makerjs.paths.Line([xh-w/2,yh], [xh-w/2, yh-3*markShift]),
    "WHLine1": new makerjs.paths.Line([xh+w/2,yh], [xh+w/2, yh-3*markShift]),
     "WHLine": new makerjs.paths.Line([xh-w/2,yh-markShift], [xh+w/2, yh-markShift]),
        }
 };
var myHangClipHMakerW1 = {
paths: {
      "W1HLine0": new makerjs.paths.Line([xh-w/2-od,yh+h1], [xh-w/2-od,yh+h1+markShiftFour]),
      "W1HLine1": new makerjs.paths.Line([xh+w/2+od,yh+h1], [xh+w/2+od,yh+h1+markShiftFour]),
     "W1HLine": new makerjs.paths.Line([xh-w/2-od,yh+h1+markShift], [xh+w/2+od,yh+h1+markShift]),
      }
};
var myHangClipHMakerD = {
      paths: {
             "DHLine0": new makerjs.paths.Line([xh+w/2+od,yh+h1], [xh+w/2+od+rd+markHolesOneD,yh+h1+rd+markHolesOneD]),
            }
};
var myHangClipHMakerX = {
      paths: {
            "XHLine0": new makerjs.paths.Line([xh-w/2,yh], [xh-w/2, yh-markShiftFour]),
            "XHLine1": new makerjs.paths.Line([xh-w/2-x0,yh], [xh-w/2-x0, yh-markShiftFour]),
            "XHLine2": new makerjs.paths.Line([xh-w/2-x0,yh-markShiftTwo], [xh-w/2, yh-markShiftTwo]),
      }
};
var myHangClipHMakerH = {
      paths: {
         "HHLine0": new makerjs.paths.Line([xh-w/2-markShiftFour,yh+h], [xh, yh+h]),
         "HHLine1": new makerjs.paths.Line([xh-w/2-markShift,yh+h], [xh-w/2-markShift, yh]),
      }
};
var myHangClipHMakerH1 = {
      paths: {
         "H1HLine0": new makerjs.paths.Line([xh+w/2,yh+h1], [xh+w/2+markShiftFour+markShift, yh+h1]),
         "H1HLine1":new makerjs.paths.Line([xh+w/2+markShiftFour,yh+h1], [xh+w/2+markShiftFour, yh]),
      }
};
makerjs.model.addCaption(myHangClipHMakerW, TxtW, [xh-w/2,yh-2*markShiftThree], [xh+w/2, yh-2*markShiftThree]);//W文字标注
makerjs.model.addCaption(myHangClipHMakerW1, TxtW1, [xh-w/2-od,yh+h1+2*markShift], [xh+w/2+od,yh+h1+2*markShift]);//W1文字标注
  makerjs.model.addCaption(myHangClipHMakerX, TxtX, [xh-w/2-x0,yh-markShiftFour], [xh-w/2, yh-markShiftFour]);//X文字标注
  makerjs.model.addCaption(myHangClipHMakerH, TxtH, [xh-w/2-markShiftFour,yh+h], [xh-w/2-markShiftFour, yh]);//H文字标注    
  makerjs.model.addCaption(myHangClipHMakerH1, TxtH1,[xh+w/2+markShiftFour+markShift,yh+h1], [xh+w/2+markShiftFour+markShift, yh]);//H1文字标注    
  makerjs.model.addCaption(myHangClipHMakerD, TxtD, [xh+w/2+od+rd+markHolesOneD,yh+h1+rd+markHolesOneD],[xh+w/2+od+rd+d+2*markHolesOneD, yh+h1+rd+d+2*markHolesOneD]);//D文字标注  
  var markers = [myHangClipHMakerX,myHangClipHMakerW,myHangClipHMakerW1,myHangClipHMakerH,myHangClipHMakerH1,myHangClipHMakerD]
} else if (area == "I") {
var myHangClipIMakerW = {
 paths: {
   "WILine0": new makerjs.paths.Line([xi,yi], [xi, yi-3*markShift]),
    "WILine1": new makerjs.paths.Line([xi-w,yi], [xi-w, yi-3*markShift]),
     "WILine": new makerjs.paths.Line([xi,yi-markShift], [xi-w, yi-markShift]),
        }
 };
var myHangClipIMakerW1 = {
paths: {
      "W1ILine0": new makerjs.paths.Line([xi+od,yi+h1], [xi+od,yi+h1+markShiftFour]),
      "W1ILine1": new makerjs.paths.Line([xi-w-od,yi+h1], [xi-w-od,yi+h1+markShiftFour]),
     "W1ILine": new makerjs.paths.Line([xi+od,yi+h1+markShift], [xi-w-od,yi+h1+markShift]),
      }
};
var myHangClipIMakerD = {
      paths: {
             "RILine0": new makerjs.paths.Line([xi-w-od,yi+h1], [xi-w-od-rd-markHolesOneD,yi+h1+rd+markHolesOneD]),
            }
};
var myHangClipIMakerX = {
      paths: {
            "XILine0": new makerjs.paths.Line([xi,yi], [xi, yi-markShiftFour]),
            "XILine1": new makerjs.paths.Line([xi+x0,yi], [xi+x0, yi-markShiftFour]),
            "XILine2": new makerjs.paths.Line([xi+x0,yi-markShiftTwo], [xi, yi-markShiftTwo]),
      }
};
var myHangClipIMakerH = {
      paths: {
         "HILine0": new makerjs.paths.Line([xi+markShiftFour,yi+h], [xi-w/2, yi+h]),
         "HILine1": new makerjs.paths.Line([xi+markShift,yi+h], [xi+markShift, yi]),
      }
};
var myHangClipIMakerH1 = {
      paths: {
         "H1ILine0": new makerjs.paths.Line([xi-w,yi+h1], [xi-w-markShiftFour-markShift, yi+h1]),
         "H1ILine1":new makerjs.paths.Line([xi-w-markShiftFour,yi+h1], [xi-w-markShiftFour, yi]),
      }
};
makerjs.model.addCaption(myHangClipIMakerW, TxtW, [xi-w,yi-2*markShiftThree], [xi, yi-2*markShiftThree]);//W文字标注
makerjs.model.addCaption(myHangClipIMakerW1, TxtW1, [xi-w-od,yi+h1+2*markShift], [xi+od,yi+h1+2*markShift]);//W1文字标注
  makerjs.model.addCaption(myHangClipIMakerX, TxtX, [xi, yi-markShiftFour], [xi+x0,yi-markShiftFour]);//X文字标注
  makerjs.model.addCaption(myHangClipIMakerH, TxtH, [xi+markShiftFour,yi+h], [xi+markShiftFour, yi]);//H文字标注    
  makerjs.model.addCaption(myHangClipIMakerH1, TxtH1,[xi-w-markShiftFour-markShift,yi+h1], [xi-w-markShiftFour-markShift, yi]);//H1文字标注    
  makerjs.model.addCaption(myHangClipIMakerD, TxtD,[xi-w-od-rd-d-2*markHolesOneD, yi+h1+rd+d+2*markHolesOneD], [xi-w-od-rd-markHolesOneD,yi+h1+rd+markHolesOneD]);//D文字标注  
  var markers = [myHangClipIMakerX,myHangClipIMakerW,myHangClipIMakerW1,myHangClipIMakerH,myHangClipIMakerH1,myHangClipIMakerD]
}      
 }
  
  console.log("markers||||||||||||||||||=", markers)
  return markers;
};
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function HangClipGap(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){

      var frame = outParam.shapeName;
      console.log("outParam==", outParam)
      console.log("model==", model)
      console.log("inputParam==", inputParam)
      console.log("outParam.shapeName==////////", outParam.shapeName)
      if (typeof (frame) == "undefined") {
            var R=inputParam.R,W=inputParam.W,W1=inputParam.W1,H1=inputParam.H1,H=inputParam.H,D=inputParam.D,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
            plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = "Rectangle",
                  glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
                  markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
                  markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
                  w= W*1*myZoom,
                  w1= W1*1*myZoom,
                  h= H*1*myZoom,
                  h1= H1*1*myZoom,
                  d= D*1*myZoom,
                  r=d/2,
                  rd=r/Math.sqrt(2),
                    x0 = X*1*myZoom,
                    y0 = Y*1*myZoom;
                    if(plate.models===undefined||plate.models===""){
                        console.log("1111111111111111");
                        plate.models={};
                                }        
                    if(cutPlate.models===undefined||cutPlate.models===""){
                                    console.log("22222222222");
                                    //cutPlate.models={};
                                    cutPlate.models={};
                                }
                    if(markers.models===undefined||markers.models===""){            
                                    console.log("333333333333");
                                    markers.models={};
                                }
                    if(d!==0){
                     var TxtD="∮"+d;
                    }
                    if(h!==0){
                     var TxtH=H;
                    }
                    if(w!==0){
                     var TxtW=W;
                    }
                    if(w1!==0){
                     var TxtW1=W1;
                    }
                    if(h1!==0){
                     var TxtH1=H1;
                    }
                    if(x0!==0){          
                    var TxtX=X;
                    }
                    if(y0!==0){          
                     var TxtY=Y;
                    }
      } else {
            var R=inputParam.R,W=inputParam.W,H1=inputParam.H1,H=inputParam.H,D=inputParam.D,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
            plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = outParam.shapeName,
                  glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
                  markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
                  markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
                  w= W*1*myZoom,
                  w1= W1*1*myZoom,
                  h= H*1*myZoom,
                  h1= H1*1*myZoom,
                  d= D*1*myZoom,
                  r=d/2,
                  rd=r/Math.sqrt(2),
                    x0 = X*1*myZoom,
                    y0 = Y*1*myZoom;
                    if(plate.models===undefined||plate.models===""){
                        console.log("1111111111111111");
                        plate.models={};
                                }        
                    if(cutPlate.models===undefined||cutPlate.models===""){
                                    console.log("22222222222");
                                    //cutPlate.models={};
                                    cutPlate.models={};
                                }
                    if(markers.models===undefined||markers.models===""){            
                                    console.log("333333333333");
                                    markers.models={};
                                }
                    
                    if(d!==0){
                     var TxtD="∮"+d;
                    }
                    if(h!==0){
                     var TxtH=H;
                    }
                    if(w!==0){
                     var TxtW=W;
                    }
                    if(w1!==0){
                     var TxtW1=W1;
                    }
                    if(h1!==0){
                     var TxtH1=H1;
                    }
                    if(x0!==0){          
                    var TxtX=X;
                    }
                    if(y0!==0){          
                     var TxtY=Y;
                    }
      }
      if (frame == "Rectangle") {
            console.log("frame==undefined||||*****")
            //在A区域 计算孔的位置       
            var xa = x0, ya = glassH * 1 - y0,
                  //B区域//只有Y标注没有X标注 
                  xb = glassW * 1 / 2, yb = glassH * 1 - y0,
                  //C区域
                  xc = glassW * 1 - x0, yc = glassH * 1 - y0,
                  //D区域
                  //只有X标注没有Y标注 
                  xd=x0,yd=glassH * 1/2,
                  //E区域
                  //只有X标注没有Y标注 
                 xe=glassW * 1/2,ye=glassH * 1/2,
                 //F区域
                //只有X标注没有Y标注 
                 xf=glassW * 1-x0,yf=glassH * 1/2,
                  //在G区域 计算孔的位置
                  xg = x0, yg = y0,
                  //在H区域 计算孔的位置
                  //只标注Y
                  xh = glassW * 1 / 2, yh = y0,
                  //在I区域 计算孔的位置
                  xi = glassW * 1 - x0, yi = y0;
                  /**
        * 已知拱高 弦长 求半径 h为拱高，l为弦长
        * r=h/2+l*l/8*h
        * o1r=h/2+w*w/8*h;半径
        */
                   var od=(w1-w)/2;//差值
                 var o1r=(h/2)+(w*w)/(8*h);//半径
                 var hrd=o1r-h;
                 console.log("xa,hrd,o1r,h=====",xa,hrd,o1r,h);
                  if(glassW*1<glassH * 1){
                        
                        
                  //   "LeftHolesA": new makerjs.paths.Circle([xa+h1, ya+od], r),
                  //   "RightHolesA":new makerjs.paths.Circle([xa+h1,ya-w-od], r),                  
                //"LeftHolesC": new makerjs.paths.Circle([xc-h1, yc+od], r),
                //"RightHolesC":new makerjs.paths.Circle([xc-h1,yc-w-od], r),                //
            //     "LeftHolesD": new makerjs.paths.Circle([xd+h1, yd+od+w/2], r),
            //     "RightHolesD":new makerjs.paths.Circle([xd+h1,yd-w/2-od], r),            
            // "LeftHolesF": new makerjs.paths.Circle([xf-h1, yf+od+w/2], r),
            // "RightHolesF":new makerjs.paths.Circle([xf-h1,yf-w/2-od], r),            
            // "LeftHolesG": new makerjs.paths.Circle([xg+h1, yg-od], r),
            // "RightHolesG":new makerjs.paths.Circle([xg+h1,yg+w+od], r),            
            // "LeftHolesI": new makerjs.paths.Circle([xi-h1, yi-od], r),
            // "RightHolesI":new makerjs.paths.Circle([xi-h1,yi+w+od], r),
//------------------------短---------------=============

      //         "LeftHolesA": new makerjs.paths.Circle([xa-od, ya-h1], r),
      //         "RightHolesA":new makerjs.paths.Circle([xa+w+od,ya-h1], r),
      //         "LeftHolesB": new makerjs.paths.Circle([xb-w/2-od, yb-h1], r),
      //         "RightHolesB":new makerjs.paths.Circle([xb+w/2+od,yb-h1], r),
      //         "LeftHolesC": new makerjs.paths.Circle([xc+od, yc-h1], r),
      //         "RightHolesC":new makerjs.paths.Circle([xc-w-od,yc-h1], r),
      //         "LeftHolesG": new makerjs.paths.Circle([xg-od, yg+h1], r),
      //         "RightHolesG":new makerjs.paths.Circle([xg+w+od,yg+h1], r),
      //           "LeftHolesH": new makerjs.paths.Circle([xh-w/2-od, yh+h1], r),
      //           "RightHolesH":new makerjs.paths.Circle([xh+w/2+od,yh+h1], r),
      //     "LeftHolesI": new makerjs.paths.Circle([xi+od, yi+h1], r),
      //     "RightHolesI":new makerjs.paths.Circle([xi-w-od,yi+h1], r),

                  //A 区域 oax1、oay1 为大圆圆心坐标；oax2,oay2 为下边圆圆心坐标；oax3,oay3 为上边圆圆心坐标；
                        var oax1=xa-hrd,oay1=ya-w/2,oax2=xa+h1,oay2=ya-w-od,oax3=xa+h1,oay3=ya+od,
                        ocx1=xc+hrd,ocy1=yc-w/2,ocx2=xc-h1,ocy2=yc+od,ocx3=xc-h1,ocy3=yc-w-od,
                        odx1=xd-hrd,ody1=yd,odx2=xd+h1,ody2=yd-od-w/2,odx3=xd+h1,ody3=yd+w/2+od,
                        ofx1=xf+hrd,ofy1=yf,ofx2=xf-h1,ofy2=yf-od-w/2,ofx3=xf-h1,ofy3=yf+w/2+od,
                        ogx1=xg-hrd,ogy1=yg+w/2,ogx2=xg+h1,ogy2=yg-od,ogx3=xg+h1,ogy3=yg+w+od,
                        oix1=xi+hrd,oiy1=yi+w/2,oix2=xi-h1,oiy2=yi-od,oix3=xi-h1,oiy3=yi+w+od;
                        console.log("oax1,oay1,oax2,oay2,o1r,r,oax3,oay3==",oax1,oay1,oax2,oay2,o1r,r,oax3,oay3);
                        console.log("ocx1,ocy1,ocx2,ocy2,o1r,r,ocx3,ocy3==",ocx1,ocy1,ocx2,ocy2,o1r,r,ocx3,ocy3);
                        console.log("odx1,ody1,odx2,ody2,o1r,r,odx3,ody3==",odx1,ody1,odx2,ody2,o1r,r,odx3,ody3);
                        console.log("oix1,oiy1,oix2,oiy2,o1r,r,oix3,oiy3==",oix1,oiy1,oix2,oiy2,o1r,r,oix3,oiy3);
                        console.log("ogx1,ogy1,ogx2,ogy2,o1r,r,ogx3,ogy3==",ogx1,ogy1,ogx2,ogy2,o1r,r,ogx3,ogy3);
                        var arrCulAdn= getCalculatingDistance(oax1,oay1,oax2,oay2,o1r,r);
                        var arrCulAup= getCalculatingDistance(oax1,oay1,oax3,oay3,o1r,r);
                        var arrCulCdn= getCalculatingDistance(ocx1,ocy1,ocx2,ocy2,o1r,r);
                        var arrCulCup= getCalculatingDistance(ocx1,ocy1,ocx3,ocy3,o1r,r);
                        var arrCulDdn= getCalculatingDistance(odx1,ody1,odx2,ody2,o1r,r);
                        var arrCulDup= getCalculatingDistance(odx1,ody1,odx3,ody3,o1r,r);
                        var arrCulFdn= getCalculatingDistance(ofx1,ofy1,ofx2,ofy2,o1r,r);
                        var arrCulFup= getCalculatingDistance(ofx1,ofy1,ofx3,ofy3,o1r,r);
                        var arrCulGdn= getCalculatingDistance(ogx1,ogy1,ogx2,ogy2,o1r,r);
                        var arrCulGup= getCalculatingDistance(ogx1,ogy1,ogx3,ogy3,o1r,r);
                        var arrCulIdn= getCalculatingDistance(oix1,oiy1,oix2,oiy2,o1r,r);
                        var arrCulIup= getCalculatingDistance(oix1,oiy1,oix3,oiy3,o1r,r);
                        console.log("arrCulAdn,arrCulAup",arrCulAdn,arrCulAup);
                     //d,X0,Y0
                     var oAddn=arrCulAdn.d,oAX1dn=arrCulAdn.X1,oAY1dn=arrCulAdn.Y1,oAX2dn=arrCulAdn.X2,oAY2dn=arrCulAdn.Y2,oAX3dn=arrCulAdn.X3,oAY3dn=arrCulAdn.Y3,
                         oAdup=arrCulAup.d,oAX1up=arrCulAup.X1,oAY1up=arrCulAup.Y1,oAX2up=arrCulAup.X2,oAY2up=arrCulAup.Y2,oAX3up=arrCulAup.X3,oAY3up=arrCulAup.Y3,
                         oCddn=arrCulCdn.d,oCX1dn=arrCulCdn.X1,oCY1dn=arrCulCdn.Y1,oCX2dn=arrCulCdn.X2,oCY2dn=arrCulCdn.Y2,oCX3dn=arrCulCdn.X3,oCY3dn=arrCulCdn.Y3,
                         oCdup=arrCulCup.d,oCX1up=arrCulCup.X1,oCY1up=arrCulCup.Y1,oCX2up=arrCulCup.X2,oCY2up=arrCulCup.Y2,oCX3up=arrCulCup.X3,oCY3up=arrCulCup.Y3,
                         oDddn=arrCulDdn.d,oDX1dn=arrCulDdn.X1,oDY1dn=arrCulDdn.Y1,oDX2dn=arrCulDdn.X2,oDY2dn=arrCulDdn.Y2,oDX3dn=arrCulDdn.X3,oDY3dn=arrCulDdn.Y3,
                         oDdup=arrCulDup.d,oDX1up=arrCulDup.X1,oDY1up=arrCulDup.Y1,oDX2up=arrCulDup.X2,oDY2up=arrCulDup.Y2,oDX3up=arrCulDup.X3,oDY3up=arrCulDup.Y3,
                         oFddn=arrCulFdn.d,oFX1dn=arrCulFdn.X1,oFY1dn=arrCulFdn.Y1,oFX2dn=arrCulFdn.X2,oFY2dn=arrCulFdn.Y2,oFX3dn=arrCulFdn.X3,oFY3dn=arrCulFdn.Y3,
                         oFdup=arrCulFup.d,oFX1up=arrCulFup.X1,oFY1up=arrCulFup.Y1,oFX2up=arrCulFup.X2,oFY2up=arrCulFup.Y2,oFX3up=arrCulFup.X3,oFY3up=arrCulFup.Y3,
                         oGddn=arrCulGdn.d,oGX1dn=arrCulGdn.X1,oGY1dn=arrCulGdn.Y1,oGX2dn=arrCulGdn.X2,oGY2dn=arrCulGdn.Y2,oGX3dn=arrCulGdn.X3,oGY3dn=arrCulGdn.Y3,
                         oGdup=arrCulGup.d,oGX1up=arrCulGup.X1,oGY1up=arrCulGup.Y1,oGX2up=arrCulGup.X2,oGY2up=arrCulGup.Y2,oGX3up=arrCulGup.X3,oGY3up=arrCulGup.Y3,
                         oIddn=arrCulIdn.d,oIX1dn=arrCulIdn.X1,oIY1dn=arrCulIdn.Y1,oIX2dn=arrCulIdn.X2,oIY2dn=arrCulIdn.Y2,oIX3dn=arrCulIdn.X3,oIY3dn=arrCulIdn.Y3,
                         oIdup=arrCulIup.d,oIX1up=arrCulIup.X1,oIY1up=arrCulIup.Y1,oIX2up=arrCulIup.X2,oIY2up=arrCulIup.Y2,oIX3up=arrCulIup.X3,oIY3up=arrCulIup.Y3;
                         console.log("oAddn,oAX1dn,oAY1dn,oAX2dn,oAY2dn,oAX3dn,oAY3dn,oAdup,oAX1up,oAY1up,oAX2up,oAY2up,oAX3up,oAY3up===",oAddn,oAX1dn,oAY1dn,oAX2dn,oAY2dn,oAX3dn,oAY3dn,oAdup,oAX1up,oAY1up,oAX2up,oAY2up,oAX3up,oAY3up,);
                        }else{
                        //A 区域 oax1、oay1 为大圆圆心坐标；oax2,oay2 为左边圆圆心坐标；oax3,oay3 为右边圆圆心坐标；
                        var oax1=xa+w/2,oay1=ya+hrd,oax2=xa-od,oay2=ya-h1,oax3=xa+w+od,oay3=ya-h1,
                        obx1=xb,oby1=yb+hrd,obx2=xb-od-w/2,oby2=yb-h1,obx3=xb+w/2+od,oby3=yb-h1,
                        ocx1=xc-w/2,ocy1=yc+hrd,ocx2=xc-w-od,ocy2=yc-h1,ocx3=xc+od,ocy3=yc-h1,
                        ogx1=xg+w/2,ogy1=yg-hrd,ogx2=xg-od,ogy2=yg+h1,ogx3=xg+w+od,ogy3=yg+h1,
                        ohx1=xh,ohy1=yh-hrd,ohx2=xh-od-w/2,ohy2=yh+h1,ohx3=xh+w/2+od,ohy3=yh+h1,
                        oix1=xi-w/2,oiy1=yi-hrd,oix2=xi-w-od,oiy2=yi+h1,oix3=xi+od,oiy3=yi+h1;
                        console.log("oax1,oay1,oax2,oay2,o1r,r,oax3,oay3==",oax1,oay1,oax2,oay2,o1r,r,oax3,oay3);
                        console.log("ocx1,ocy1,ocx2,ocy2,o1r,r,ocx3,ocy3==",ocx1,ocy1,ocx2,ocy2,o1r,r,ocx3,ocy3);
                        // console.log("odx1,ody1,odx2,ody2,o1r,r,odx3,ody3==",odx1,ody1,odx2,ody2,o1r,r,odx3,ody3);
                        console.log("oix1,oiy1,oix2,oiy2,o1r,r,oix3,oiy3==",oix1,oiy1,oix2,oiy2,o1r,r,oix3,oiy3);
                        console.log("ogx1,ogy1,ogx2,ogy2,o1r,r,ogx3,ogy3==",ogx1,ogy1,ogx2,ogy2,o1r,r,ogx3,ogy3);
                        var arrCulAdn= getCalculatingDistance(oax1,oay1,oax2,oay2,o1r,r);
                        var arrCulAup= getCalculatingDistance(oax1,oay1,oax3,oay3,o1r,r);
                        var arrCulBdn= getCalculatingDistance(obx1,oby1,obx2,oby2,o1r,r);
                        var arrCulBup= getCalculatingDistance(obx1,oby1,obx3,oby3,o1r,r);
                        var arrCulCdn= getCalculatingDistance(ocx1,ocy1,ocx2,ocy2,o1r,r);
                        var arrCulCup= getCalculatingDistance(ocx1,ocy1,ocx3,ocy3,o1r,r);
                        var arrCulGdn= getCalculatingDistance(ogx1,ogy1,ogx2,ogy2,o1r,r);
                        var arrCulGup= getCalculatingDistance(ogx1,ogy1,ogx3,ogy3,o1r,r);
                        var arrCulHdn= getCalculatingDistance(ohx1,ohy1,ohx2,ohy2,o1r,r);
                        var arrCulHup= getCalculatingDistance(ohx1,ohy1,ohx3,ohy3,o1r,r);
                        var arrCulIdn= getCalculatingDistance(oix1,oiy1,oix2,oiy2,o1r,r);
                        var arrCulIup= getCalculatingDistance(oix1,oiy1,oix3,oiy3,o1r,r);
                     //d,X0,Y0
                     var oAddn=arrCulAdn.d,oAX1dn=arrCulAdn.X1,oAY1dn=arrCulAdn.Y1,oAX2dn=arrCulAdn.X2,oAY2dn=arrCulAdn.Y2,oAX3dn=arrCulAdn.X3,oAY3dn=arrCulAdn.Y3,
                         oAdup=arrCulAup.d,oAX1up=arrCulAup.X1,oAY1up=arrCulAup.Y1,oAX2up=arrCulAup.X2,oAY2up=arrCulAup.Y2,oAX3up=arrCulAup.X3,oAY3up=arrCulAup.Y3,
                         oBddn=arrCulBdn.d,oBX1dn=arrCulBdn.X1,oBY1dn=arrCulBdn.Y1,oBX2dn=arrCulBdn.X2,oBY2dn=arrCulBdn.Y2,oBX3dn=arrCulBdn.X3,oBY3dn=arrCulBdn.Y3,
                         oBdup=arrCulBup.d,oBX1up=arrCulBup.X1,oBY1up=arrCulBup.Y1,oBX2up=arrCulBup.X2,oBY2up=arrCulBup.Y2,oBX3up=arrCulBup.X3,oBY3up=arrCulBup.Y3,
                         oCddn=arrCulCdn.d,oCX1dn=arrCulCdn.X1,oCY1dn=arrCulCdn.Y1,oCX2dn=arrCulCdn.X2,oCY2dn=arrCulCdn.Y2,oCX3dn=arrCulCdn.X3,oCY3dn=arrCulCdn.Y3,
                         oCdup=arrCulCup.d,oCX1up=arrCulCup.X1,oCY1up=arrCulCup.Y1,oCX2up=arrCulCup.X2,oCY2up=arrCulCup.Y2,oCX3up=arrCulCup.X3,oCY3up=arrCulCup.Y3,
                         oGddn=arrCulGdn.d,oGX1dn=arrCulGdn.X1,oGY1dn=arrCulGdn.Y1,oGX2dn=arrCulGdn.X2,oGY2dn=arrCulGdn.Y2,oGX3dn=arrCulGdn.X3,oGY3dn=arrCulGdn.Y3,
                         oGdup=arrCulGup.d,oGX1up=arrCulGup.X1,oGY1up=arrCulGup.Y1,oGX2up=arrCulGup.X2,oGY2up=arrCulGup.Y2,oGX3up=arrCulGup.X3,oGY3up=arrCulGup.Y3,
                         oHddn=arrCulHdn.d,oHX1dn=arrCulHdn.X1,oHY1dn=arrCulHdn.Y1,oHX2dn=arrCulHdn.X2,oHY2dn=arrCulHdn.Y2,oHX3dn=arrCulHdn.X3,oHY3dn=arrCulHdn.Y3,
                         oHdup=arrCulHup.d,oHX1up=arrCulHup.X1,oHY1up=arrCulHup.Y1,oHX2up=arrCulHup.X2,oHY2up=arrCulHup.Y2,oHX3up=arrCulHup.X3,oHY3up=arrCulHup.Y3,
                         oIddn=arrCulIdn.d,oIX1dn=arrCulIdn.X1,oIY1dn=arrCulIdn.Y1,oIX2dn=arrCulIdn.X2,oIY2dn=arrCulIdn.Y2,oIX3dn=arrCulIdn.X3,oIY3dn=arrCulIdn.Y3,
                         oIdup=arrCulIup.d,oIX1up=arrCulIup.X1,oIY1up=arrCulIup.Y1,oIX2up=arrCulIup.X2,oIY2up=arrCulIup.Y2,oIX3up=arrCulIup.X3,oIY3up=arrCulIup.Y3;
                  }
 //oAddn,oAX1dn,oAY1dn,oAX2dn,oAY2dn,oAX3dn,oAY3dn,oBddn,oBX1dn,oBY1dn,oBX2dn,oBY2dn,oBX3dn,oBY3dn,oCddn,oCX1dn,oCY1dn,oCX2dn,oCY2dn,oCX3dn,oCY3dn,oDddn,oDX1dn,oDY1dn,oDX2dn,oDY2dn,oDX3dn,oDY3dn,oFddn,oFX1dn,oFY1dn,oFX2dn,oFY2dn,oFX3dn,oFY3dn,oGddn,oGX1dn,oGY1dn,oGX2dn,oGY2dn,oGX3dn,oGY3dn,oHddn,oHX1dn,oHY1dn,oHX2dn,oHY2dn,oHX3dn,oHY3dn,oIddn,oIX1dn,oIY1dn,oIX2dn,oIY2dn,oIX3dn,oIY3dn,oAdup,oAX1up,oAY1up,oAX2up,oAY2up,oAX3up,oAY3up,oBdup,oBX1up,oBY1up,oBX2up,oBY2up,oBX3up,oBY3up,oCdup,oCX1up,oCY1up,oCX2up,oCY2up,oCX3up,oCY3up,oDdup,oDX1up,oDY1up,oDX2up,oDY2up,oDX3up,oDY3up,oFdup,oFX1up,oFY1up,oFX2up,oFY2up,oFX3up,oFY3up,oGdup,oGX1up,oGY1up,oGX2up,oGY2up,oGX3up,oGY3up,oHdup,oHX1up,oHY1up,oHX2up,oHY2up,oHX3up,oHY3up,oIdup,oIX1up,oIY1up,oIX2up,oIY2up,oIX3up,oIY3up                
            var OffsetParam = {};
      } else if (frame == "IsoscelesTrapezoid") {
      } else if (frame == "RightAngledTrapezoid") {
      } else if (frame == "OtherTrapezoidsA") {
      } else if (frame == "OtherTrapezoidsB") {
      } else if (frame == "ParallelogramA") {
      } else if (frame == "ParallelogramB") {
      }
      // 坐标参数
      var paramCoordinate = { hrd,o1r,x0,y0,rd,r,cutLine,cutFilletRadius,w,w1,h1,h,d,xa, ya, xb, yb, xc, yc, xd, yd, xf, yf, xg, yg, xh, yh, xi, yi,glassW,glassH,oAddn,oAX1dn,oAY1dn,oAX2dn,oAY2dn,oAX3dn,oAY3dn,oBddn,oBX1dn,oBY1dn,oBX2dn,oBY2dn,oBX3dn,oBY3dn,oCddn,oCX1dn,oCY1dn,oCX2dn,oCY2dn,oCX3dn,oCY3dn,oDddn,oDX1dn,oDY1dn,oDX2dn,oDY2dn,oDX3dn,oDY3dn,oFddn,oFX1dn,oFY1dn,oFX2dn,oFY2dn,oFX3dn,oFY3dn,oGddn,oGX1dn,oGY1dn,oGX2dn,oGY2dn,oGX3dn,oGY3dn,oHddn,oHX1dn,oHY1dn,oHX2dn,oHY2dn,oHX3dn,oHY3dn,oIddn,oIX1dn,oIY1dn,oIX2dn,oIY2dn,oIX3dn,oIY3dn,oAdup,oAX1up,oAY1up,oAX2up,oAY2up,oAX3up,oAY3up,oBdup,oBX1up,oBY1up,oBX2up,oBY2up,oBX3up,oBY3up,oCdup,oCX1up,oCY1up,oCX2up,oCY2up,oCX3up,oCY3up,oDdup,oDX1up,oDY1up,oDX2up,oDY2up,oDX3up,oDY3up,oFdup,oFX1up,oFY1up,oFX2up,oFY2up,oFX3up,oFY3up,oGdup,oGX1up,oGY1up,oGX2up,oGY2up,oGX3up,oGY3up,oHdup,oHX1up,oHY1up,oHX2up,oHY2up,oHX3up,oHY3up,oIdup,oIX1up,oIY1up,oIX2up,oIY2up,oIX3up,oIY3up};
      const allKeys = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(model.plate.models)));
      var areaPoint = "";
      console.log("//缺8、吊夹 ------", allKeys)
      if (allKeys[0] == frame) {
            allKeys.shift();//去掉数组第一个元素
      }
      console.log("//缺9、吊夹 位置去掉数组第一个元素------", allKeys)
      switch (area) {
            case "1": areaPoint = "A"; break;
            case "2": areaPoint = "B"; break;
            case "3": areaPoint = "C"; break;
            case "4": areaPoint = "D"; break;
            case "6": areaPoint = "F"; break;
            case "7": areaPoint = "G"; break;
            case "8": areaPoint = "H"; break;
            case "9": areaPoint = "I"; break;
      }
      /**
      * 画图
      * 
      */
      var ObjName = "myHangClipGap" + areaPoint;
      var ObjNameMmyHangClipGap = "myHangClipGap" + areaPoint + "Mark";//角标记
      ObjName = creatmyHangClipGap(areaPoint, paramCoordinate);//图形
      console.log("ObjName===|||||||||", ObjName);
      ObjNameMmyHangClipGap = creatmyHangClipGapMark(outParam, areaPoint, paramCoordinate, inputParam, fixedParam, OffsetParam, zoom);//图形
      console.log("ObjNameMmyHangClipGap===|||||||||角标注", ObjNameMmyHangClipGap);
      console.log("cutPlate.models====************", cutPlate.models),
            console.log("plate.models====**************", plate.models),
            console.log("markers.models====*************", markers.models),
         // myHangClipAMakerH,myHangClipAMakerX,myHangClipAMakerR,myHangClipAMakerW,myHangClipAMakerH1,myHangClipAMakerD
            cutPlate.models["TypeGapes_myHangClipGap" + areaPoint + myHolesNum] = ObjName[2];
      plate.models["TypeGapes_myHangClipGap" + areaPoint + myHolesNum] = ObjName[2];
      markers.models["TypeGapes_myHangClipGap" + areaPoint + myHolesNum] = ObjName[2];
      markers.models["TypeGapes_myHangClipGapX" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyHangClipGap[0];
      markers.models["TypeGapes_myHangClipGapW" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyHangClipGap[1];
      markers.models["TypeGapes_myHangClipGapW1" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyHangClipGap[2];
      markers.models["TypeGapes_myHangClipGap" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyHangClipGap[3];
      markers.models["TypeGapes_myHangClipGap1" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyHangClipGap[4];
      markers.models["TypeGapes_myHangClipGapD" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyHangClipGap[5];

myHolesNum++;
return{plate,cutPlate,markers, myHolesNum}
};


export default HangClipGap;